//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const UTEX_API_BASE_URL = new InjectionToken<string>('UTEX_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class UTEXService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(UTEX_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAuditRecords(body?: AuditRecordDto[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Audit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAuditRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAuditRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processCreateAuditRecords(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    get(): Observable<ConnectionHealthInfo[]> {
        let url_ = this.baseUrl + "/api/ConnectionHealth";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConnectionHealthInfo[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConnectionHealthInfo[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ConnectionHealthInfo[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConnectionHealthInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param docGroupId (optional) 
     * @return Success
     */
    getDocGroupMappings(docGroupId?: number | undefined): Observable<DocGroupMappingDto[]> {
        let url_ = this.baseUrl + "/api/DocGroupMappings?";
        if (docGroupId === null)
            throw new globalThis.Error("The parameter 'docGroupId' cannot be null.");
        else if (docGroupId !== undefined)
            url_ += "docGroupId=" + encodeURIComponent("" + docGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocGroupMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocGroupMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocGroupMappingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocGroupMappingDto[]>;
        }));
    }

    protected processGetDocGroupMappings(response: HttpResponseBase): Observable<DocGroupMappingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocGroupMappingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param errorCodeId (optional) 
     * @param companyCodeId (optional) 
     * @return Success
     */
    getErrorResolutionReasonMappings(errorCodeId?: number | undefined, companyCodeId?: number | undefined): Observable<ErrorResolutionReasonMappingDto[]> {
        let url_ = this.baseUrl + "/api/ErrorResolutionReasonMappings?";
        if (errorCodeId === null)
            throw new globalThis.Error("The parameter 'errorCodeId' cannot be null.");
        else if (errorCodeId !== undefined)
            url_ += "errorCodeId=" + encodeURIComponent("" + errorCodeId) + "&";
        if (companyCodeId === null)
            throw new globalThis.Error("The parameter 'companyCodeId' cannot be null.");
        else if (companyCodeId !== undefined)
            url_ += "companyCodeId=" + encodeURIComponent("" + companyCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErrorResolutionReasonMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErrorResolutionReasonMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorResolutionReasonMappingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorResolutionReasonMappingDto[]>;
        }));
    }

    protected processGetErrorResolutionReasonMappings(response: HttpResponseBase): Observable<ErrorResolutionReasonMappingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErrorResolutionReasonMappingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateErrorResolutionReasonMapping(body?: ErrorResolutionReasonMappingDto | undefined): Observable<ErrorResolutionReasonMappingDto> {
        let url_ = this.baseUrl + "/api/ErrorResolutionReasonMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateErrorResolutionReasonMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateErrorResolutionReasonMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorResolutionReasonMappingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorResolutionReasonMappingDto>;
        }));
    }

    protected processUpdateErrorResolutionReasonMapping(response: HttpResponseBase): Observable<ErrorResolutionReasonMappingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorResolutionReasonMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createErrorResolutionReasonMapping(body?: ErrorResolutionReasonMappingDto | undefined): Observable<ErrorResolutionReasonMappingDto> {
        let url_ = this.baseUrl + "/api/ErrorResolutionReasonMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateErrorResolutionReasonMapping(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateErrorResolutionReasonMapping(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorResolutionReasonMappingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorResolutionReasonMappingDto>;
        }));
    }

    protected processCreateErrorResolutionReasonMapping(response: HttpResponseBase): Observable<ErrorResolutionReasonMappingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ErrorResolutionReasonMappingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param mappingIds (optional) 
     * @return Success
     */
    deleteErrorResolutionReasonMappings(mappingIds?: number[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/ErrorResolutionReasonMappings?";
        if (mappingIds === null)
            throw new globalThis.Error("The parameter 'mappingIds' cannot be null.");
        else if (mappingIds !== undefined)
            mappingIds && mappingIds.forEach(item => { url_ += "mappingIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteErrorResolutionReasonMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteErrorResolutionReasonMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processDeleteErrorResolutionReasonMappings(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyCode (optional) 
     * @return Success
     */
    getTemporaryGracePeriodReasons(companyCode?: string | undefined): Observable<TemporaryGracePeriodReasonsDto[]> {
        let url_ = this.baseUrl + "/api/ErrorResolutionReasonMappings/temporarygraceperiodreasons?";
        if (companyCode === null)
            throw new globalThis.Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined)
            url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemporaryGracePeriodReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemporaryGracePeriodReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemporaryGracePeriodReasonsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemporaryGracePeriodReasonsDto[]>;
        }));
    }

    protected processGetTemporaryGracePeriodReasons(response: HttpResponseBase): Observable<TemporaryGracePeriodReasonsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemporaryGracePeriodReasonsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param errorCodeId (optional) 
     * @return Success
     */
    getErrorRules(errorCodeId?: number | undefined): Observable<ErrorRuleDto[]> {
        let url_ = this.baseUrl + "/api/ErrorRules?";
        if (errorCodeId === null)
            throw new globalThis.Error("The parameter 'errorCodeId' cannot be null.");
        else if (errorCodeId !== undefined)
            url_ += "errorCodeId=" + encodeURIComponent("" + errorCodeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetErrorRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetErrorRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ErrorRuleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ErrorRuleDto[]>;
        }));
    }

    protected processGetErrorRules(response: HttpResponseBase): Observable<ErrorRuleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ErrorRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    addNew(body?: any | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Exception/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddNew(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     * @deprecated
     */
    getOverrides(utexId: number): Observable<RuleOverrideDTO[]> {
        let url_ = this.baseUrl + "/api/Exception/GetOverrides/{utexId}";
        if (utexId === undefined || utexId === null)
            throw new globalThis.Error("The parameter 'utexId' must be defined.");
        url_ = url_.replace("{utexId}", encodeURIComponent("" + utexId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverrides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverrides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RuleOverrideDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RuleOverrideDTO[]>;
        }));
    }

    protected processGetOverrides(response: HttpResponseBase): Observable<RuleOverrideDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RuleOverrideDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    getSuspended(body?: SuspendedShiftRequest | undefined): Observable<UtexDTO[]> {
        let url_ = this.baseUrl + "/api/Exception/GetSuspendedShifts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuspended(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuspended(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtexDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtexDTO[]>;
        }));
    }

    protected processGetSuspended(response: HttpResponseBase): Observable<UtexDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtexDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    setUtexStatus(body?: SetUtexStatusRequest | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Exception/SetUtexStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetUtexStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetUtexStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetUtexStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cCIds (optional) 
     * @param eCIds (optional) 
     * @param exceptionId (optional) 
     * @param reIds (optional) 
     * @param utIds (optional) 
     * @param sortCol (optional) 
     * @param sortDir (optional) 
     * @param filterCol (optional) 
     * @param filterVal (optional) 
     * @param size (optional) 
     * @param page (optional) 
     * @return Success
     */
    getExceptions(cCIds?: number[] | undefined, eCIds?: number[] | undefined, exceptionId?: number | undefined, reIds?: number[] | undefined, utIds?: number[] | undefined, sortCol?: string | undefined, sortDir?: string | undefined, filterCol?: string | undefined, filterVal?: string | undefined, size?: number | undefined, page?: number | undefined): Observable<ExceptionDto[]> {
        let url_ = this.baseUrl + "/api/Exceptions?";
        if (cCIds === null)
            throw new globalThis.Error("The parameter 'cCIds' cannot be null.");
        else if (cCIds !== undefined)
            cCIds && cCIds.forEach(item => { url_ += "cCIds=" + encodeURIComponent("" + item) + "&"; });
        if (eCIds === null)
            throw new globalThis.Error("The parameter 'eCIds' cannot be null.");
        else if (eCIds !== undefined)
            eCIds && eCIds.forEach(item => { url_ += "eCIds=" + encodeURIComponent("" + item) + "&"; });
        if (exceptionId === null)
            throw new globalThis.Error("The parameter 'exceptionId' cannot be null.");
        else if (exceptionId !== undefined)
            url_ += "exceptionId=" + encodeURIComponent("" + exceptionId) + "&";
        if (reIds === null)
            throw new globalThis.Error("The parameter 'reIds' cannot be null.");
        else if (reIds !== undefined)
            reIds && reIds.forEach(item => { url_ += "reIds=" + encodeURIComponent("" + item) + "&"; });
        if (utIds === null)
            throw new globalThis.Error("The parameter 'utIds' cannot be null.");
        else if (utIds !== undefined)
            utIds && utIds.forEach(item => { url_ += "utIds=" + encodeURIComponent("" + item) + "&"; });
        if (sortCol === null)
            throw new globalThis.Error("The parameter 'sortCol' cannot be null.");
        else if (sortCol !== undefined)
            url_ += "SortCol=" + encodeURIComponent("" + sortCol) + "&";
        if (sortDir === null)
            throw new globalThis.Error("The parameter 'sortDir' cannot be null.");
        else if (sortDir !== undefined)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        if (filterCol === null)
            throw new globalThis.Error("The parameter 'filterCol' cannot be null.");
        else if (filterCol !== undefined)
            url_ += "FilterCol=" + encodeURIComponent("" + filterCol) + "&";
        if (filterVal === null)
            throw new globalThis.Error("The parameter 'filterVal' cannot be null.");
        else if (filterVal !== undefined)
            url_ += "FilterVal=" + encodeURIComponent("" + filterVal) + "&";
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "Size=" + encodeURIComponent("" + size) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExceptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExceptionDto[]>;
        }));
    }

    protected processGetExceptions(response: HttpResponseBase): Observable<ExceptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExceptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    updateException(body?: ExceptionDto[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Exceptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processUpdateException(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createException(body?: ExceptionDto[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Exceptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateException(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateException(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processCreateException(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyCode (optional) 
     * @param dGIds (optional) 
     * @return Success
     */
    getExceptionsCounts(companyCode?: string | undefined, dGIds?: number[] | undefined): Observable<ExceptionCountDTO[]> {
        let url_ = this.baseUrl + "/api/Exceptions/Counts?";
        if (companyCode === null)
            throw new globalThis.Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined)
            url_ += "companyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (dGIds === null)
            throw new globalThis.Error("The parameter 'dGIds' cannot be null.");
        else if (dGIds !== undefined)
            dGIds && dGIds.forEach(item => { url_ += "dGIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceptionsCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceptionsCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExceptionCountDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExceptionCountDTO[]>;
        }));
    }

    protected processGetExceptionsCounts(response: HttpResponseBase): Observable<ExceptionCountDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExceptionCountDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editUtexRecord(body?: EditUtexRecordDTO | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Exceptions/EditUtexRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditUtexRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditUtexRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processEditUtexRecord(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMassResolutions(body?: MassResolutionUpdateDTO | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/Exceptions/MassResolutions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMassResolutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMassResolutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processUpdateMassResolutions(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param eCId (optional) 
     * @param stIds (optional) 
     * @param dGIds (optional) 
     * @param exId (optional) 
     * @param caregiverId (optional) 
     * @param exTranId (optional) 
     * @param participantId (optional) 
     * @param tcn (optional) 
     * @return Success
     */
    getMassResolutions(companyCode: string, eCId?: number[] | undefined, stIds?: number[] | undefined, dGIds?: number[] | undefined, exId?: number | undefined, caregiverId?: string | undefined, exTranId?: string | undefined, participantId?: string | undefined, tcn?: string | undefined): Observable<MassResolutionDTO[]> {
        let url_ = this.baseUrl + "/api/Exceptions/MassResolutions/Company/{companyCode}?";
        if (companyCode === undefined || companyCode === null)
            throw new globalThis.Error("The parameter 'companyCode' must be defined.");
        url_ = url_.replace("{companyCode}", encodeURIComponent("" + companyCode));
        if (eCId === null)
            throw new globalThis.Error("The parameter 'eCId' cannot be null.");
        else if (eCId !== undefined)
            eCId && eCId.forEach(item => { url_ += "eCId=" + encodeURIComponent("" + item) + "&"; });
        if (stIds === null)
            throw new globalThis.Error("The parameter 'stIds' cannot be null.");
        else if (stIds !== undefined)
            stIds && stIds.forEach(item => { url_ += "stIds=" + encodeURIComponent("" + item) + "&"; });
        if (dGIds === null)
            throw new globalThis.Error("The parameter 'dGIds' cannot be null.");
        else if (dGIds !== undefined)
            dGIds && dGIds.forEach(item => { url_ += "dGIds=" + encodeURIComponent("" + item) + "&"; });
        if (exId === null)
            throw new globalThis.Error("The parameter 'exId' cannot be null.");
        else if (exId !== undefined)
            url_ += "exId=" + encodeURIComponent("" + exId) + "&";
        if (caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' cannot be null.");
        else if (caregiverId !== undefined)
            url_ += "caregiverId=" + encodeURIComponent("" + caregiverId) + "&";
        if (exTranId === null)
            throw new globalThis.Error("The parameter 'exTranId' cannot be null.");
        else if (exTranId !== undefined)
            url_ += "exTranId=" + encodeURIComponent("" + exTranId) + "&";
        if (participantId === null)
            throw new globalThis.Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "participantId=" + encodeURIComponent("" + participantId) + "&";
        if (tcn === null)
            throw new globalThis.Error("The parameter 'tcn' cannot be null.");
        else if (tcn !== undefined)
            url_ += "tcn=" + encodeURIComponent("" + tcn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMassResolutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMassResolutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MassResolutionDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MassResolutionDTO[]>;
        }));
    }

    protected processGetMassResolutions(response: HttpResponseBase): Observable<MassResolutionDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MassResolutionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param utexId (optional) 
     * @return Success
     */
    getExceptionHistory(utexId?: number | undefined): Observable<HistoryExceptionDTO[]> {
        let url_ = this.baseUrl + "/api/History?";
        if (utexId === null)
            throw new globalThis.Error("The parameter 'utexId' cannot be null.");
        else if (utexId !== undefined)
            url_ += "utexId=" + encodeURIComponent("" + utexId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExceptionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExceptionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoryExceptionDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoryExceptionDTO[]>;
        }));
    }

    protected processGetExceptionHistory(response: HttpResponseBase): Observable<HistoryExceptionDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HistoryExceptionDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     * @deprecated
     */
    execSproc(body?: JsonizedSprocRequest | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/JsonizedSproc/ExecSproc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecSproc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecSproc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExecSproc(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param typeIds (optional) 
     * @param valueId (optional) 
     * @return Success
     */
    getLookupValues(typeIds?: number[] | undefined, valueId?: number | undefined): Observable<LookupValueDto[]> {
        let url_ = this.baseUrl + "/api/LookupValues?";
        if (typeIds === null)
            throw new globalThis.Error("The parameter 'typeIds' cannot be null.");
        else if (typeIds !== undefined)
            typeIds && typeIds.forEach(item => { url_ += "typeIds=" + encodeURIComponent("" + item) + "&"; });
        if (valueId === null)
            throw new globalThis.Error("The parameter 'valueId' cannot be null.");
        else if (valueId !== undefined)
            url_ += "valueId=" + encodeURIComponent("" + valueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLookupValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLookupValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupValueDto[]>;
        }));
    }

    protected processGetLookupValues(response: HttpResponseBase): Observable<LookupValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupValueDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLookupValue(body?: LookupValueDto | undefined): Observable<LookupValueDto> {
        let url_ = this.baseUrl + "/api/LookupValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLookupValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLookupValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupValueDto>;
        }));
    }

    protected processUpdateLookupValue(response: HttpResponseBase): Observable<LookupValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createLookupValue(body?: LookupValueDto | undefined): Observable<LookupValueDto> {
        let url_ = this.baseUrl + "/api/LookupValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLookupValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLookupValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupValueDto>;
        }));
    }

    protected processCreateLookupValue(response: HttpResponseBase): Observable<LookupValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LookupValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    ping(): Observable<void> {
        let url_ = this.baseUrl + "/api/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param resolutionId (optional) 
     * @return Success
     */
    getResolutionStatusMappings(resolutionId?: number | undefined): Observable<ResolutionStatusMappingDto[]> {
        let url_ = this.baseUrl + "/api/ResolutionStatusMappings?";
        if (resolutionId === null)
            throw new globalThis.Error("The parameter 'resolutionId' cannot be null.");
        else if (resolutionId !== undefined)
            url_ += "resolutionId=" + encodeURIComponent("" + resolutionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResolutionStatusMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResolutionStatusMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolutionStatusMappingDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolutionStatusMappingDto[]>;
        }));
    }

    protected processGetResolutionStatusMappings(response: HttpResponseBase): Observable<ResolutionStatusMappingDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResolutionStatusMappingDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUtexRecords(body?: UtexRecordDto[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/UtexRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUtexRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtexRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processUpdateUtexRecords(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUtexRecords(body?: UtexRecordDto[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/UtexRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUtexRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUtexRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processCreateUtexRecords(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    splitUtexRecord(utexId: number, body?: SplitDTO | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/UtexRecords/{utexId}";
        if (utexId === undefined || utexId === null)
            throw new globalThis.Error("The parameter 'utexId' must be defined.");
        url_ = url_.replace("{utexId}", encodeURIComponent("" + utexId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSplitUtexRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSplitUtexRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSplitUtexRecord(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUtexRecords(body?: UtexRecordsRequest | undefined): Observable<UtexRecordDto[]> {
        let url_ = this.baseUrl + "/api/UtexRecords/fetch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtexRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtexRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtexRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtexRecordDto[]>;
        }));
    }

    protected processGetUtexRecords(response: HttpResponseBase): Observable<UtexRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UtexRecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param companyCode (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param caregiverId (optional) 
     * @param participantId (optional) 
     * @param exTransId (optional) 
     * @param status (optional) 
     * @param errorCode (optional) 
     * @param tcn (optional) 
     * @return Success
     */
    viewUtexRecords(companyCode?: string | undefined, startDate?: Date | undefined, endDate?: Date | undefined, caregiverId?: string | undefined, participantId?: string | undefined, exTransId?: string | undefined, status?: number[] | undefined, errorCode?: number[] | undefined, tcn?: string | undefined): Observable<ViewUtexRecordDTO[]> {
        let url_ = this.baseUrl + "/api/UtexRecords/view?";
        if (companyCode === null)
            throw new globalThis.Error("The parameter 'companyCode' cannot be null.");
        else if (companyCode !== undefined)
            url_ += "CompanyCode=" + encodeURIComponent("" + companyCode) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (caregiverId === null)
            throw new globalThis.Error("The parameter 'caregiverId' cannot be null.");
        else if (caregiverId !== undefined)
            url_ += "CaregiverId=" + encodeURIComponent("" + caregiverId) + "&";
        if (participantId === null)
            throw new globalThis.Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "ParticipantId=" + encodeURIComponent("" + participantId) + "&";
        if (exTransId === null)
            throw new globalThis.Error("The parameter 'exTransId' cannot be null.");
        else if (exTransId !== undefined)
            url_ += "ExTransId=" + encodeURIComponent("" + exTransId) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (errorCode === null)
            throw new globalThis.Error("The parameter 'errorCode' cannot be null.");
        else if (errorCode !== undefined)
            errorCode && errorCode.forEach(item => { url_ += "ErrorCode=" + encodeURIComponent("" + item) + "&"; });
        if (tcn === null)
            throw new globalThis.Error("The parameter 'tcn' cannot be null.");
        else if (tcn !== undefined)
            url_ += "Tcn=" + encodeURIComponent("" + tcn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processViewUtexRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewUtexRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ViewUtexRecordDTO[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ViewUtexRecordDTO[]>;
        }));
    }

    protected processViewUtexRecords(response: HttpResponseBase): Observable<ViewUtexRecordDTO[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ViewUtexRecordDTO.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = InternalServerErrorModel.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AuditRecordDto implements IAuditRecordDto {
    utexId?: number;
    payorId?: string | undefined;
    cloudSyncFileId?: string | undefined;
    companyCodeId?: number;
    companyCode?: string | undefined;
    oldParticipantId?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    documentId?: number;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    externalTransactionId?: string | undefined;
    originalTCN?: string | undefined;
    parentId?: number;
    payUnits?: number;
    recordTypeId?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceTimeInManualOriginal?: string | undefined;
    serviceTimeInCalculated?: string | undefined;
    serviceTimeOutManualOriginal?: string | undefined;
    serviceTimeOutCalculated?: string | undefined;
    serviceTimeInActual?: Date;
    serviceTimeOutActual?: Date;
    sourceId?: number | undefined;
    sourceValue?: string | undefined;
    statusId?: number | undefined;
    tcn?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    agreementNumber?: string | undefined;
    billUnits?: number;
    billRate?: number;
    billTotal?: number;
    account?: string | undefined;
    accountExp?: string | undefined;
    accountSub?: string | undefined;
    billStatus?: string | undefined;
    payStatus?: string | undefined;
    payDate?: Date;
    payRate?: number;
    payTotal?: number;
    unitType?: string | undefined;
    earnType?: string | undefined;
    ein?: string | undefined;
    holiday?: string | undefined;
    apMail?: string | undefined;
    providerNumber?: string | undefined;
    program?: string | undefined;
    documentRow?: number;
    budgetStatus?: string | undefined;
    bdStatus?: string | undefined;
    bdId?: number;
    notes?: string | undefined;
    billRateManual?: number;
    billUnitsManual?: number;
    payRateManual?: number;
    payUnitsManual?: number;
    caregiverSigDate?: Date;
    participantSigDate?: Date;
    reasonId?: number | undefined;
    reasonDescription?: string | undefined;
    auditId?: number;
    exceptionId?: number;
    resolution?: number;
    reason?: number;

    constructor(data?: IAuditRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utexId = _data["utexId"];
            this.payorId = _data["payorId"];
            this.cloudSyncFileId = _data["cloudSyncFileId"];
            this.companyCodeId = _data["companyCodeId"];
            this.companyCode = _data["companyCode"];
            this.oldParticipantId = _data["oldParticipantId"];
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"];
            this.documentId = _data["documentId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.externalTransactionId = _data["externalTransactionId"];
            this.originalTCN = _data["originalTCN"];
            this.parentId = _data["parentId"];
            this.payUnits = _data["payUnits"];
            this.recordTypeId = _data["recordTypeId"];
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : undefined as any;
            this.serviceTimeInManual = _data["serviceTimeInManual"];
            this.serviceTimeOutManual = _data["serviceTimeOutManual"];
            this.serviceTimeInManualOriginal = _data["serviceTimeInManualOriginal"];
            this.serviceTimeInCalculated = _data["serviceTimeInCalculated"];
            this.serviceTimeOutManualOriginal = _data["serviceTimeOutManualOriginal"];
            this.serviceTimeOutCalculated = _data["serviceTimeOutCalculated"];
            this.serviceTimeInActual = _data["serviceTimeInActual"] ? new Date(_data["serviceTimeInActual"].toString()) : undefined as any;
            this.serviceTimeOutActual = _data["serviceTimeOutActual"] ? new Date(_data["serviceTimeOutActual"].toString()) : undefined as any;
            this.sourceId = _data["sourceId"];
            this.sourceValue = _data["sourceValue"];
            this.statusId = _data["statusId"];
            this.tcn = _data["tcn"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.agreementNumber = _data["agreementNumber"];
            this.billUnits = _data["billUnits"];
            this.billRate = _data["billRate"];
            this.billTotal = _data["billTotal"];
            this.account = _data["account"];
            this.accountExp = _data["accountExp"];
            this.accountSub = _data["accountSub"];
            this.billStatus = _data["billStatus"];
            this.payStatus = _data["payStatus"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : undefined as any;
            this.payRate = _data["payRate"];
            this.payTotal = _data["payTotal"];
            this.unitType = _data["unitType"];
            this.earnType = _data["earnType"];
            this.ein = _data["ein"];
            this.holiday = _data["holiday"];
            this.apMail = _data["apMail"];
            this.providerNumber = _data["providerNumber"];
            this.program = _data["program"];
            this.documentRow = _data["documentRow"];
            this.budgetStatus = _data["budgetStatus"];
            this.bdStatus = _data["bdStatus"];
            this.bdId = _data["bdId"];
            this.notes = _data["notes"];
            this.billRateManual = _data["billRateManual"];
            this.billUnitsManual = _data["billUnitsManual"];
            this.payRateManual = _data["payRateManual"];
            this.payUnitsManual = _data["payUnitsManual"];
            this.caregiverSigDate = _data["caregiverSigDate"] ? new Date(_data["caregiverSigDate"].toString()) : undefined as any;
            this.participantSigDate = _data["participantSigDate"] ? new Date(_data["participantSigDate"].toString()) : undefined as any;
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.auditId = _data["auditId"];
            this.exceptionId = _data["exceptionId"];
            this.resolution = _data["resolution"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AuditRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utexId"] = this.utexId;
        data["payorId"] = this.payorId;
        data["cloudSyncFileId"] = this.cloudSyncFileId;
        data["companyCodeId"] = this.companyCodeId;
        data["companyCode"] = this.companyCode;
        data["oldParticipantId"] = this.oldParticipantId;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType;
        data["documentId"] = this.documentId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["externalTransactionId"] = this.externalTransactionId;
        data["originalTCN"] = this.originalTCN;
        data["parentId"] = this.parentId;
        data["payUnits"] = this.payUnits;
        data["recordTypeId"] = this.recordTypeId;
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : undefined as any;
        data["serviceTimeInManual"] = this.serviceTimeInManual;
        data["serviceTimeOutManual"] = this.serviceTimeOutManual;
        data["serviceTimeInManualOriginal"] = this.serviceTimeInManualOriginal;
        data["serviceTimeInCalculated"] = this.serviceTimeInCalculated;
        data["serviceTimeOutManualOriginal"] = this.serviceTimeOutManualOriginal;
        data["serviceTimeOutCalculated"] = this.serviceTimeOutCalculated;
        data["serviceTimeInActual"] = this.serviceTimeInActual ? this.serviceTimeInActual.toISOString() : undefined as any;
        data["serviceTimeOutActual"] = this.serviceTimeOutActual ? this.serviceTimeOutActual.toISOString() : undefined as any;
        data["sourceId"] = this.sourceId;
        data["sourceValue"] = this.sourceValue;
        data["statusId"] = this.statusId;
        data["tcn"] = this.tcn;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["agreementNumber"] = this.agreementNumber;
        data["billUnits"] = this.billUnits;
        data["billRate"] = this.billRate;
        data["billTotal"] = this.billTotal;
        data["account"] = this.account;
        data["accountExp"] = this.accountExp;
        data["accountSub"] = this.accountSub;
        data["billStatus"] = this.billStatus;
        data["payStatus"] = this.payStatus;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : undefined as any;
        data["payRate"] = this.payRate;
        data["payTotal"] = this.payTotal;
        data["unitType"] = this.unitType;
        data["earnType"] = this.earnType;
        data["ein"] = this.ein;
        data["holiday"] = this.holiday;
        data["apMail"] = this.apMail;
        data["providerNumber"] = this.providerNumber;
        data["program"] = this.program;
        data["documentRow"] = this.documentRow;
        data["budgetStatus"] = this.budgetStatus;
        data["bdStatus"] = this.bdStatus;
        data["bdId"] = this.bdId;
        data["notes"] = this.notes;
        data["billRateManual"] = this.billRateManual;
        data["billUnitsManual"] = this.billUnitsManual;
        data["payRateManual"] = this.payRateManual;
        data["payUnitsManual"] = this.payUnitsManual;
        data["caregiverSigDate"] = this.caregiverSigDate ? this.caregiverSigDate.toISOString() : undefined as any;
        data["participantSigDate"] = this.participantSigDate ? this.participantSigDate.toISOString() : undefined as any;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["auditId"] = this.auditId;
        data["exceptionId"] = this.exceptionId;
        data["resolution"] = this.resolution;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IAuditRecordDto {
    utexId?: number;
    payorId?: string | undefined;
    cloudSyncFileId?: string | undefined;
    companyCodeId?: number;
    companyCode?: string | undefined;
    oldParticipantId?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    documentId?: number;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    externalTransactionId?: string | undefined;
    originalTCN?: string | undefined;
    parentId?: number;
    payUnits?: number;
    recordTypeId?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceTimeInManualOriginal?: string | undefined;
    serviceTimeInCalculated?: string | undefined;
    serviceTimeOutManualOriginal?: string | undefined;
    serviceTimeOutCalculated?: string | undefined;
    serviceTimeInActual?: Date;
    serviceTimeOutActual?: Date;
    sourceId?: number | undefined;
    sourceValue?: string | undefined;
    statusId?: number | undefined;
    tcn?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    agreementNumber?: string | undefined;
    billUnits?: number;
    billRate?: number;
    billTotal?: number;
    account?: string | undefined;
    accountExp?: string | undefined;
    accountSub?: string | undefined;
    billStatus?: string | undefined;
    payStatus?: string | undefined;
    payDate?: Date;
    payRate?: number;
    payTotal?: number;
    unitType?: string | undefined;
    earnType?: string | undefined;
    ein?: string | undefined;
    holiday?: string | undefined;
    apMail?: string | undefined;
    providerNumber?: string | undefined;
    program?: string | undefined;
    documentRow?: number;
    budgetStatus?: string | undefined;
    bdStatus?: string | undefined;
    bdId?: number;
    notes?: string | undefined;
    billRateManual?: number;
    billUnitsManual?: number;
    payRateManual?: number;
    payUnitsManual?: number;
    caregiverSigDate?: Date;
    participantSigDate?: Date;
    reasonId?: number | undefined;
    reasonDescription?: string | undefined;
    auditId?: number;
    exceptionId?: number;
    resolution?: number;
    reason?: number;
}

export class ConnectionHealthInfo implements IConnectionHealthInfo {
    connectionString?: string | undefined;
    healthStatusCode?: HealthStatusCode;
    status?: string | undefined;
    time?: string | undefined;
    response?: string | undefined;
    sourceID?: string | undefined;
    instrumentationKey?: string | undefined;

    constructor(data?: IConnectionHealthInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.healthStatusCode = _data["healthStatusCode"];
            this.status = _data["status"];
            this.time = _data["time"];
            this.response = _data["response"];
            this.sourceID = _data["sourceID"];
            this.instrumentationKey = _data["instrumentationKey"];
        }
    }

    static fromJS(data: any): ConnectionHealthInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectionHealthInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["healthStatusCode"] = this.healthStatusCode;
        data["status"] = this.status;
        data["time"] = this.time;
        data["response"] = this.response;
        data["sourceID"] = this.sourceID;
        data["instrumentationKey"] = this.instrumentationKey;
        return data;
    }
}

export interface IConnectionHealthInfo {
    connectionString?: string | undefined;
    healthStatusCode?: HealthStatusCode;
    status?: string | undefined;
    time?: string | undefined;
    response?: string | undefined;
    sourceID?: string | undefined;
    instrumentationKey?: string | undefined;
}

export class DocGroupMappingDto implements IDocGroupMappingDto {
    mappingId?: number;
    docTypeId?: number;
    docGroupId?: number;

    constructor(data?: IDocGroupMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mappingId = _data["mappingId"];
            this.docTypeId = _data["docTypeId"];
            this.docGroupId = _data["docGroupId"];
        }
    }

    static fromJS(data: any): DocGroupMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocGroupMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mappingId"] = this.mappingId;
        data["docTypeId"] = this.docTypeId;
        data["docGroupId"] = this.docGroupId;
        return data;
    }
}

export interface IDocGroupMappingDto {
    mappingId?: number;
    docTypeId?: number;
    docGroupId?: number;
}

export enum DocType {
    Enrichmentdata = "Enrichmentdata",
    Shift = "Shift",
    Mileage = "Mileage",
    Fee = "Fee",
    GHS = "GHS",
    GHA = "GHA",
    Vendor = "Vendor",
    SHA = "SHA",
    MLA = "MLA",
}

export class EditUtexRecordDTO implements IEditUtexRecordDTO {
    recordToResolve?: MassResolutionUpdateDTO;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    isZeroMinute?: boolean;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceCode?: string | undefined;
    currentStatusId?: number;
    payDate?: Date;
    sigCustDate?: Date;
    sigEmpDate?: Date;
    billUnitsManual?: number | undefined;
    payUnitsManual?: number | undefined;
    payRate?: number | undefined;

    constructor(data?: IEditUtexRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordToResolve = _data["recordToResolve"] ? MassResolutionUpdateDTO.fromJS(_data["recordToResolve"]) : undefined as any;
            this.participantId = _data["participantId"];
            this.caregiverId = _data["caregiverId"];
            this.isZeroMinute = _data["isZeroMinute"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : undefined as any;
            this.serviceTimeInManual = _data["serviceTimeInManual"];
            this.serviceTimeOutManual = _data["serviceTimeOutManual"];
            this.serviceCode = _data["serviceCode"];
            this.currentStatusId = _data["currentStatusId"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : undefined as any;
            this.sigCustDate = _data["sigCustDate"] ? new Date(_data["sigCustDate"].toString()) : undefined as any;
            this.sigEmpDate = _data["sigEmpDate"] ? new Date(_data["sigEmpDate"].toString()) : undefined as any;
            this.billUnitsManual = _data["billUnitsManual"];
            this.payUnitsManual = _data["payUnitsManual"];
            this.payRate = _data["payRate"];
        }
    }

    static fromJS(data: any): EditUtexRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new EditUtexRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordToResolve"] = this.recordToResolve ? this.recordToResolve.toJSON() : undefined as any;
        data["participantId"] = this.participantId;
        data["caregiverId"] = this.caregiverId;
        data["isZeroMinute"] = this.isZeroMinute;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : undefined as any;
        data["serviceTimeInManual"] = this.serviceTimeInManual;
        data["serviceTimeOutManual"] = this.serviceTimeOutManual;
        data["serviceCode"] = this.serviceCode;
        data["currentStatusId"] = this.currentStatusId;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : undefined as any;
        data["sigCustDate"] = this.sigCustDate ? this.sigCustDate.toISOString() : undefined as any;
        data["sigEmpDate"] = this.sigEmpDate ? this.sigEmpDate.toISOString() : undefined as any;
        data["billUnitsManual"] = this.billUnitsManual;
        data["payUnitsManual"] = this.payUnitsManual;
        data["payRate"] = this.payRate;
        return data;
    }
}

export interface IEditUtexRecordDTO {
    recordToResolve?: MassResolutionUpdateDTO;
    participantId?: string | undefined;
    caregiverId?: string | undefined;
    isZeroMinute?: boolean;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceCode?: string | undefined;
    currentStatusId?: number;
    payDate?: Date;
    sigCustDate?: Date;
    sigEmpDate?: Date;
    billUnitsManual?: number | undefined;
    payUnitsManual?: number | undefined;
    payRate?: number | undefined;
}

export class ErrorResolutionReasonMappingDto implements IErrorResolutionReasonMappingDto {
    errorCodeId?: number;
    mappingId?: number;
    reasonId?: number;
    resolutionId?: number;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    companyCodeId?: number | undefined;

    constructor(data?: IErrorResolutionReasonMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCodeId = _data["errorCodeId"];
            this.mappingId = _data["mappingId"];
            this.reasonId = _data["reasonId"];
            this.resolutionId = _data["resolutionId"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.companyCodeId = _data["companyCodeId"];
        }
    }

    static fromJS(data: any): ErrorResolutionReasonMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResolutionReasonMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCodeId"] = this.errorCodeId;
        data["mappingId"] = this.mappingId;
        data["reasonId"] = this.reasonId;
        data["resolutionId"] = this.resolutionId;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["companyCodeId"] = this.companyCodeId;
        return data;
    }
}

export interface IErrorResolutionReasonMappingDto {
    errorCodeId?: number;
    mappingId?: number;
    reasonId?: number;
    resolutionId?: number;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    companyCodeId?: number | undefined;
}

export class ErrorRuleDto implements IErrorRuleDto {
    allowSplitShift?: boolean;
    apiRuleId?: string | undefined;
    errorCodeId?: number;
    errorDescription?: string | undefined;
    priority?: number;
    resolutionId?: number;
    ruleId?: string | undefined;
    shortDescription?: string | undefined;

    constructor(data?: IErrorRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSplitShift = _data["allowSplitShift"];
            this.apiRuleId = _data["apiRuleId"];
            this.errorCodeId = _data["errorCodeId"];
            this.errorDescription = _data["errorDescription"];
            this.priority = _data["priority"];
            this.resolutionId = _data["resolutionId"];
            this.ruleId = _data["ruleId"];
            this.shortDescription = _data["shortDescription"];
        }
    }

    static fromJS(data: any): ErrorRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSplitShift"] = this.allowSplitShift;
        data["apiRuleId"] = this.apiRuleId;
        data["errorCodeId"] = this.errorCodeId;
        data["errorDescription"] = this.errorDescription;
        data["priority"] = this.priority;
        data["resolutionId"] = this.resolutionId;
        data["ruleId"] = this.ruleId;
        data["shortDescription"] = this.shortDescription;
        return data;
    }
}

export interface IErrorRuleDto {
    allowSplitShift?: boolean;
    apiRuleId?: string | undefined;
    errorCodeId?: number;
    errorDescription?: string | undefined;
    priority?: number;
    resolutionId?: number;
    ruleId?: string | undefined;
    shortDescription?: string | undefined;
}

export class ExceptionCountDTO implements IExceptionCountDTO {
    newCount?: number;
    pendingCount?: number;
    errorCodeValue?: string | undefined;
    errorDescription?: string | undefined;
    errorCodeId?: number;
    priority?: number;

    constructor(data?: IExceptionCountDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newCount = _data["newCount"];
            this.pendingCount = _data["pendingCount"];
            this.errorCodeValue = _data["errorCodeValue"];
            this.errorDescription = _data["errorDescription"];
            this.errorCodeId = _data["errorCodeId"];
            this.priority = _data["priority"];
        }
    }

    static fromJS(data: any): ExceptionCountDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExceptionCountDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newCount"] = this.newCount;
        data["pendingCount"] = this.pendingCount;
        data["errorCodeValue"] = this.errorCodeValue;
        data["errorDescription"] = this.errorDescription;
        data["errorCodeId"] = this.errorCodeId;
        data["priority"] = this.priority;
        return data;
    }
}

export interface IExceptionCountDTO {
    newCount?: number;
    pendingCount?: number;
    errorCodeValue?: string | undefined;
    errorDescription?: string | undefined;
    errorCodeId?: number;
    priority?: number;
}

export class ExceptionDto implements IExceptionDto {
    companyCodeId?: number;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    errorCodeId?: number;
    errorDescription?: string | undefined;
    errors?: string | undefined;
    exceptionId?: number;
    originalExceptionId?: number;
    reasonId?: number | undefined;
    resolutionId?: number | undefined;
    ruleId?: string | undefined;
    utexId?: number;

    constructor(data?: IExceptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCodeId = _data["companyCodeId"];
            this.createdBy = _data["createdBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.errorCodeId = _data["errorCodeId"];
            this.errorDescription = _data["errorDescription"];
            this.errors = _data["errors"];
            this.exceptionId = _data["exceptionId"];
            this.originalExceptionId = _data["originalExceptionId"];
            this.reasonId = _data["reasonId"];
            this.resolutionId = _data["resolutionId"];
            this.ruleId = _data["ruleId"];
            this.utexId = _data["utexId"];
        }
    }

    static fromJS(data: any): ExceptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExceptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCodeId"] = this.companyCodeId;
        data["createdBy"] = this.createdBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["errorCodeId"] = this.errorCodeId;
        data["errorDescription"] = this.errorDescription;
        data["errors"] = this.errors;
        data["exceptionId"] = this.exceptionId;
        data["originalExceptionId"] = this.originalExceptionId;
        data["reasonId"] = this.reasonId;
        data["resolutionId"] = this.resolutionId;
        data["ruleId"] = this.ruleId;
        data["utexId"] = this.utexId;
        return data;
    }
}

export interface IExceptionDto {
    companyCodeId?: number;
    createdBy?: string | undefined;
    createdOn?: Date | undefined;
    errorCodeId?: number;
    errorDescription?: string | undefined;
    errors?: string | undefined;
    exceptionId?: number;
    originalExceptionId?: number;
    reasonId?: number | undefined;
    resolutionId?: number | undefined;
    ruleId?: string | undefined;
    utexId?: number;
}

export enum HealthStatusCode {
    Bad = "Bad",
    Ok = "Ok",
}

export class HistoryExceptionDTO implements IHistoryExceptionDTO {
    exceptionID?: number;
    errorCode?: string | undefined;
    resolution?: string | undefined;
    reason?: string | undefined;
    createdBy?: string | undefined;
    creationTime?: Date;
    utexId?: number;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    serviceDate?: Date;
    serviceCode?: string | undefined;
    timeInMan?: string | undefined;
    timeOutMan?: string | undefined;
    isAudit?: boolean;
    payRate?: number;
    creationDate?: string | undefined;

    constructor(data?: IHistoryExceptionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exceptionID = _data["exceptionID"];
            this.errorCode = _data["errorCode"];
            this.resolution = _data["resolution"];
            this.reason = _data["reason"];
            this.createdBy = _data["createdBy"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : undefined as any;
            this.utexId = _data["utexId"];
            this.caregiverId = _data["caregiverId"];
            this.participantId = _data["participantId"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : undefined as any;
            this.serviceCode = _data["serviceCode"];
            this.timeInMan = _data["timeInMan"];
            this.timeOutMan = _data["timeOutMan"];
            this.isAudit = _data["isAudit"];
            this.payRate = _data["payRate"];
            this.creationDate = _data["creationDate"];
        }
    }

    static fromJS(data: any): HistoryExceptionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryExceptionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionID"] = this.exceptionID;
        data["errorCode"] = this.errorCode;
        data["resolution"] = this.resolution;
        data["reason"] = this.reason;
        data["createdBy"] = this.createdBy;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        data["utexId"] = this.utexId;
        data["caregiverId"] = this.caregiverId;
        data["participantId"] = this.participantId;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : undefined as any;
        data["serviceCode"] = this.serviceCode;
        data["timeInMan"] = this.timeInMan;
        data["timeOutMan"] = this.timeOutMan;
        data["isAudit"] = this.isAudit;
        data["payRate"] = this.payRate;
        data["creationDate"] = this.creationDate;
        return data;
    }
}

export interface IHistoryExceptionDTO {
    exceptionID?: number;
    errorCode?: string | undefined;
    resolution?: string | undefined;
    reason?: string | undefined;
    createdBy?: string | undefined;
    creationTime?: Date;
    utexId?: number;
    caregiverId?: string | undefined;
    participantId?: string | undefined;
    serviceDate?: Date;
    serviceCode?: string | undefined;
    timeInMan?: string | undefined;
    timeOutMan?: string | undefined;
    isAudit?: boolean;
    payRate?: number;
    creationDate?: string | undefined;
}

export class HttpFilterRequest implements IHttpFilterRequest {
    sortCol?: string | undefined;
    sortDir?: string | undefined;
    filterCol?: string | undefined;
    filterVal?: string | undefined;
    size?: number;
    page?: number;

    constructor(data?: IHttpFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortCol = _data["sortCol"];
            this.sortDir = _data["sortDir"];
            this.filterCol = _data["filterCol"];
            this.filterVal = _data["filterVal"];
            this.size = _data["size"];
            this.page = _data["page"];
        }
    }

    static fromJS(data: any): HttpFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new HttpFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortCol"] = this.sortCol;
        data["sortDir"] = this.sortDir;
        data["filterCol"] = this.filterCol;
        data["filterVal"] = this.filterVal;
        data["size"] = this.size;
        data["page"] = this.page;
        return data;
    }
}

export interface IHttpFilterRequest {
    sortCol?: string | undefined;
    sortDir?: string | undefined;
    filterCol?: string | undefined;
    filterVal?: string | undefined;
    size?: number;
    page?: number;
}

export class InternalServerErrorModel implements IInternalServerErrorModel {
    readonly message?: string | undefined;
    error?: string | undefined;

    constructor(data?: IInternalServerErrorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).message = _data["message"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): InternalServerErrorModel {
        data = typeof data === 'object' ? data : {};
        let result = new InternalServerErrorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["error"] = this.error;
        return data;
    }
}

export interface IInternalServerErrorModel {
    message?: string | undefined;
    error?: string | undefined;
}

export class JsonizedSprocRequest implements IJsonizedSprocRequest {
    sProcName?: string | undefined;
    sProcParamName?: string | undefined;
    sProcOutParamName?: string | undefined;
    sProcPayload?: any | undefined;

    constructor(data?: IJsonizedSprocRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sProcName = _data["sProcName"];
            this.sProcParamName = _data["sProcParamName"];
            this.sProcOutParamName = _data["sProcOutParamName"];
            this.sProcPayload = _data["sProcPayload"];
        }
    }

    static fromJS(data: any): JsonizedSprocRequest {
        data = typeof data === 'object' ? data : {};
        let result = new JsonizedSprocRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sProcName"] = this.sProcName;
        data["sProcParamName"] = this.sProcParamName;
        data["sProcOutParamName"] = this.sProcOutParamName;
        data["sProcPayload"] = this.sProcPayload;
        return data;
    }
}

export interface IJsonizedSprocRequest {
    sProcName?: string | undefined;
    sProcParamName?: string | undefined;
    sProcOutParamName?: string | undefined;
    sProcPayload?: any | undefined;
}

export class LookupValueDto implements ILookupValueDto {
    sortOrder?: number | undefined;
    typeId?: number;
    typeName?: string | undefined;
    value?: string | undefined;
    valueId?: number;

    constructor(data?: ILookupValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.typeId = _data["typeId"];
            this.typeName = _data["typeName"];
            this.value = _data["value"];
            this.valueId = _data["valueId"];
        }
    }

    static fromJS(data: any): LookupValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["typeId"] = this.typeId;
        data["typeName"] = this.typeName;
        data["value"] = this.value;
        data["valueId"] = this.valueId;
        return data;
    }
}

export interface ILookupValueDto {
    sortOrder?: number | undefined;
    typeId?: number;
    typeName?: string | undefined;
    value?: string | undefined;
    valueId?: number;
}

export class MassResolutionDTO implements IMassResolutionDTO {
    utexId?: number;
    payorId?: string | undefined;
    cloudSyncFileId?: string | undefined;
    companyCodeId?: number;
    companyCode?: string | undefined;
    oldParticipantId?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    documentId?: number;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    externalTransactionId?: string | undefined;
    originalTCN?: string | undefined;
    parentId?: number;
    payUnits?: number;
    recordTypeId?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceTimeInManualOriginal?: string | undefined;
    serviceTimeInCalculated?: string | undefined;
    serviceTimeOutManualOriginal?: string | undefined;
    serviceTimeOutCalculated?: string | undefined;
    serviceTimeInActual?: Date;
    serviceTimeOutActual?: Date;
    sourceId?: number | undefined;
    sourceValue?: string | undefined;
    statusId?: number | undefined;
    tcn?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    agreementNumber?: string | undefined;
    billUnits?: number;
    billRate?: number;
    billTotal?: number;
    account?: string | undefined;
    accountExp?: string | undefined;
    accountSub?: string | undefined;
    billStatus?: string | undefined;
    payStatus?: string | undefined;
    payDate?: Date;
    payRate?: number;
    payTotal?: number;
    unitType?: string | undefined;
    earnType?: string | undefined;
    ein?: string | undefined;
    holiday?: string | undefined;
    apMail?: string | undefined;
    providerNumber?: string | undefined;
    program?: string | undefined;
    documentRow?: number;
    budgetStatus?: string | undefined;
    bdStatus?: string | undefined;
    bdId?: number;
    notes?: string | undefined;
    billRateManual?: number;
    billUnitsManual?: number;
    payRateManual?: number;
    payUnitsManual?: number;
    caregiverSigDate?: Date;
    participantSigDate?: Date;
    reasonId?: number | undefined;
    reasonDescription?: string | undefined;
    exceptionId?: number;
    errorCodeId?: number;
    errorCodeValue?: string | undefined;
    exceptionAge?: number;
    utexAge?: number;
    sigCust?: number;
    sigCustDate?: Date | undefined;
    sigEmp?: number;
    sigEmpDate?: Date | undefined;
    rowInitials?: boolean;
    task?: boolean;
    allowShiftSplit?: boolean;
    historyExist?: boolean;
    notesExist?: boolean;
    isOverride?: boolean;
    ruleId?: string | undefined;
    vendorId?: string | undefined;
    vendorName?: string | undefined;
    clientChosenVendorId?: string | undefined;
    invoiceNumber?: string | undefined;

    constructor(data?: IMassResolutionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utexId = _data["utexId"];
            this.payorId = _data["payorId"];
            this.cloudSyncFileId = _data["cloudSyncFileId"];
            this.companyCodeId = _data["companyCodeId"];
            this.companyCode = _data["companyCode"];
            this.oldParticipantId = _data["oldParticipantId"];
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"];
            this.documentId = _data["documentId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.externalTransactionId = _data["externalTransactionId"];
            this.originalTCN = _data["originalTCN"];
            this.parentId = _data["parentId"];
            this.payUnits = _data["payUnits"];
            this.recordTypeId = _data["recordTypeId"];
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : undefined as any;
            this.serviceTimeInManual = _data["serviceTimeInManual"];
            this.serviceTimeOutManual = _data["serviceTimeOutManual"];
            this.serviceTimeInManualOriginal = _data["serviceTimeInManualOriginal"];
            this.serviceTimeInCalculated = _data["serviceTimeInCalculated"];
            this.serviceTimeOutManualOriginal = _data["serviceTimeOutManualOriginal"];
            this.serviceTimeOutCalculated = _data["serviceTimeOutCalculated"];
            this.serviceTimeInActual = _data["serviceTimeInActual"] ? new Date(_data["serviceTimeInActual"].toString()) : undefined as any;
            this.serviceTimeOutActual = _data["serviceTimeOutActual"] ? new Date(_data["serviceTimeOutActual"].toString()) : undefined as any;
            this.sourceId = _data["sourceId"];
            this.sourceValue = _data["sourceValue"];
            this.statusId = _data["statusId"];
            this.tcn = _data["tcn"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.agreementNumber = _data["agreementNumber"];
            this.billUnits = _data["billUnits"];
            this.billRate = _data["billRate"];
            this.billTotal = _data["billTotal"];
            this.account = _data["account"];
            this.accountExp = _data["accountExp"];
            this.accountSub = _data["accountSub"];
            this.billStatus = _data["billStatus"];
            this.payStatus = _data["payStatus"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : undefined as any;
            this.payRate = _data["payRate"];
            this.payTotal = _data["payTotal"];
            this.unitType = _data["unitType"];
            this.earnType = _data["earnType"];
            this.ein = _data["ein"];
            this.holiday = _data["holiday"];
            this.apMail = _data["apMail"];
            this.providerNumber = _data["providerNumber"];
            this.program = _data["program"];
            this.documentRow = _data["documentRow"];
            this.budgetStatus = _data["budgetStatus"];
            this.bdStatus = _data["bdStatus"];
            this.bdId = _data["bdId"];
            this.notes = _data["notes"];
            this.billRateManual = _data["billRateManual"];
            this.billUnitsManual = _data["billUnitsManual"];
            this.payRateManual = _data["payRateManual"];
            this.payUnitsManual = _data["payUnitsManual"];
            this.caregiverSigDate = _data["caregiverSigDate"] ? new Date(_data["caregiverSigDate"].toString()) : undefined as any;
            this.participantSigDate = _data["participantSigDate"] ? new Date(_data["participantSigDate"].toString()) : undefined as any;
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.exceptionId = _data["exceptionId"];
            this.errorCodeId = _data["errorCodeId"];
            this.errorCodeValue = _data["errorCodeValue"];
            this.exceptionAge = _data["exceptionAge"];
            this.utexAge = _data["utexAge"];
            this.sigCust = _data["sigCust"];
            this.sigCustDate = _data["sigCustDate"] ? new Date(_data["sigCustDate"].toString()) : undefined as any;
            this.sigEmp = _data["sigEmp"];
            this.sigEmpDate = _data["sigEmpDate"] ? new Date(_data["sigEmpDate"].toString()) : undefined as any;
            this.rowInitials = _data["rowInitials"];
            this.task = _data["task"];
            this.allowShiftSplit = _data["allowShiftSplit"];
            this.historyExist = _data["historyExist"];
            this.notesExist = _data["notesExist"];
            this.isOverride = _data["isOverride"];
            this.ruleId = _data["ruleId"];
            this.vendorId = _data["vendorId"];
            this.vendorName = _data["vendorName"];
            this.clientChosenVendorId = _data["clientChosenVendorId"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }

    static fromJS(data: any): MassResolutionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MassResolutionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utexId"] = this.utexId;
        data["payorId"] = this.payorId;
        data["cloudSyncFileId"] = this.cloudSyncFileId;
        data["companyCodeId"] = this.companyCodeId;
        data["companyCode"] = this.companyCode;
        data["oldParticipantId"] = this.oldParticipantId;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType;
        data["documentId"] = this.documentId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["externalTransactionId"] = this.externalTransactionId;
        data["originalTCN"] = this.originalTCN;
        data["parentId"] = this.parentId;
        data["payUnits"] = this.payUnits;
        data["recordTypeId"] = this.recordTypeId;
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : undefined as any;
        data["serviceTimeInManual"] = this.serviceTimeInManual;
        data["serviceTimeOutManual"] = this.serviceTimeOutManual;
        data["serviceTimeInManualOriginal"] = this.serviceTimeInManualOriginal;
        data["serviceTimeInCalculated"] = this.serviceTimeInCalculated;
        data["serviceTimeOutManualOriginal"] = this.serviceTimeOutManualOriginal;
        data["serviceTimeOutCalculated"] = this.serviceTimeOutCalculated;
        data["serviceTimeInActual"] = this.serviceTimeInActual ? this.serviceTimeInActual.toISOString() : undefined as any;
        data["serviceTimeOutActual"] = this.serviceTimeOutActual ? this.serviceTimeOutActual.toISOString() : undefined as any;
        data["sourceId"] = this.sourceId;
        data["sourceValue"] = this.sourceValue;
        data["statusId"] = this.statusId;
        data["tcn"] = this.tcn;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["agreementNumber"] = this.agreementNumber;
        data["billUnits"] = this.billUnits;
        data["billRate"] = this.billRate;
        data["billTotal"] = this.billTotal;
        data["account"] = this.account;
        data["accountExp"] = this.accountExp;
        data["accountSub"] = this.accountSub;
        data["billStatus"] = this.billStatus;
        data["payStatus"] = this.payStatus;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : undefined as any;
        data["payRate"] = this.payRate;
        data["payTotal"] = this.payTotal;
        data["unitType"] = this.unitType;
        data["earnType"] = this.earnType;
        data["ein"] = this.ein;
        data["holiday"] = this.holiday;
        data["apMail"] = this.apMail;
        data["providerNumber"] = this.providerNumber;
        data["program"] = this.program;
        data["documentRow"] = this.documentRow;
        data["budgetStatus"] = this.budgetStatus;
        data["bdStatus"] = this.bdStatus;
        data["bdId"] = this.bdId;
        data["notes"] = this.notes;
        data["billRateManual"] = this.billRateManual;
        data["billUnitsManual"] = this.billUnitsManual;
        data["payRateManual"] = this.payRateManual;
        data["payUnitsManual"] = this.payUnitsManual;
        data["caregiverSigDate"] = this.caregiverSigDate ? this.caregiverSigDate.toISOString() : undefined as any;
        data["participantSigDate"] = this.participantSigDate ? this.participantSigDate.toISOString() : undefined as any;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["exceptionId"] = this.exceptionId;
        data["errorCodeId"] = this.errorCodeId;
        data["errorCodeValue"] = this.errorCodeValue;
        data["exceptionAge"] = this.exceptionAge;
        data["utexAge"] = this.utexAge;
        data["sigCust"] = this.sigCust;
        data["sigCustDate"] = this.sigCustDate ? this.sigCustDate.toISOString() : undefined as any;
        data["sigEmp"] = this.sigEmp;
        data["sigEmpDate"] = this.sigEmpDate ? this.sigEmpDate.toISOString() : undefined as any;
        data["rowInitials"] = this.rowInitials;
        data["task"] = this.task;
        data["allowShiftSplit"] = this.allowShiftSplit;
        data["historyExist"] = this.historyExist;
        data["notesExist"] = this.notesExist;
        data["isOverride"] = this.isOverride;
        data["ruleId"] = this.ruleId;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["clientChosenVendorId"] = this.clientChosenVendorId;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}

export interface IMassResolutionDTO {
    utexId?: number;
    payorId?: string | undefined;
    cloudSyncFileId?: string | undefined;
    companyCodeId?: number;
    companyCode?: string | undefined;
    oldParticipantId?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    documentId?: number;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    externalTransactionId?: string | undefined;
    originalTCN?: string | undefined;
    parentId?: number;
    payUnits?: number;
    recordTypeId?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceTimeInManualOriginal?: string | undefined;
    serviceTimeInCalculated?: string | undefined;
    serviceTimeOutManualOriginal?: string | undefined;
    serviceTimeOutCalculated?: string | undefined;
    serviceTimeInActual?: Date;
    serviceTimeOutActual?: Date;
    sourceId?: number | undefined;
    sourceValue?: string | undefined;
    statusId?: number | undefined;
    tcn?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    agreementNumber?: string | undefined;
    billUnits?: number;
    billRate?: number;
    billTotal?: number;
    account?: string | undefined;
    accountExp?: string | undefined;
    accountSub?: string | undefined;
    billStatus?: string | undefined;
    payStatus?: string | undefined;
    payDate?: Date;
    payRate?: number;
    payTotal?: number;
    unitType?: string | undefined;
    earnType?: string | undefined;
    ein?: string | undefined;
    holiday?: string | undefined;
    apMail?: string | undefined;
    providerNumber?: string | undefined;
    program?: string | undefined;
    documentRow?: number;
    budgetStatus?: string | undefined;
    bdStatus?: string | undefined;
    bdId?: number;
    notes?: string | undefined;
    billRateManual?: number;
    billUnitsManual?: number;
    payRateManual?: number;
    payUnitsManual?: number;
    caregiverSigDate?: Date;
    participantSigDate?: Date;
    reasonId?: number | undefined;
    reasonDescription?: string | undefined;
    exceptionId?: number;
    errorCodeId?: number;
    errorCodeValue?: string | undefined;
    exceptionAge?: number;
    utexAge?: number;
    sigCust?: number;
    sigCustDate?: Date | undefined;
    sigEmp?: number;
    sigEmpDate?: Date | undefined;
    rowInitials?: boolean;
    task?: boolean;
    allowShiftSplit?: boolean;
    historyExist?: boolean;
    notesExist?: boolean;
    isOverride?: boolean;
    ruleId?: string | undefined;
    vendorId?: string | undefined;
    vendorName?: string | undefined;
    clientChosenVendorId?: string | undefined;
    invoiceNumber?: string | undefined;
}

export class MassResolutionUpdateDTO implements IMassResolutionUpdateDTO {
    exceptionIds?: number[] | undefined;
    resolutionId?: number;
    reasonId?: number;
    createdBy?: string | undefined;

    constructor(data?: IMassResolutionUpdateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["exceptionIds"])) {
                this.exceptionIds = [] as any;
                for (let item of _data["exceptionIds"])
                    this.exceptionIds!.push(item);
            }
            this.resolutionId = _data["resolutionId"];
            this.reasonId = _data["reasonId"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): MassResolutionUpdateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MassResolutionUpdateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.exceptionIds)) {
            data["exceptionIds"] = [];
            for (let item of this.exceptionIds)
                data["exceptionIds"].push(item);
        }
        data["resolutionId"] = this.resolutionId;
        data["reasonId"] = this.reasonId;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IMassResolutionUpdateDTO {
    exceptionIds?: number[] | undefined;
    resolutionId?: number;
    reasonId?: number;
    createdBy?: string | undefined;
}

export class ResolutionStatusMappingDto implements IResolutionStatusMappingDto {
    resolutionId?: number;
    statusId?: number;

    constructor(data?: IResolutionStatusMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resolutionId = _data["resolutionId"];
            this.statusId = _data["statusId"];
        }
    }

    static fromJS(data: any): ResolutionStatusMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResolutionStatusMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resolutionId"] = this.resolutionId;
        data["statusId"] = this.statusId;
        return data;
    }
}

export interface IResolutionStatusMappingDto {
    resolutionId?: number;
    statusId?: number;
}

export enum RuleId {
    ParticipantSig = "ParticipantSig",
    CaregiverSig = "CaregiverSig",
    Participant = "Participant",
    ServiceCode = "ServiceCode",
    Program = "Program",
    ServiceDate = "ServiceDate",
    TimeTest = "TimeTest",
    AuthHeader = "AuthHeader",
    AuthOnHold = "AuthOnHold",
    AuthOverlap = "AuthOverlap",
    BillRateOverlap = "BillRateOverlap",
    AuthCode = "AuthCode",
    ParticipantEmployer = "ParticipantEmployer",
    Caregiver = "Caregiver",
    ParticipantCaregiverRel = "ParticipantCaregiverRel",
    LateService = "LateService",
    InvoiceNumber = "InvoiceNumber",
    PayUnits = "PayUnits",
    PayRate = "PayRate",
    BillUnits = "BillUnits",
    BillRate = "BillRate",
    ExceededWWL = "ExceededWWL",
    ServiceTimeOverlap = "ServiceTimeOverlap",
    OverBudgetDollars = "OverBudgetDollars",
    OverBudgetUnits = "OverBudgetUnits",
    ExpenseAccount = "ExpenseAccount",
    RevenueAccount = "RevenueAccount",
    SubAccount = "SubAccount",
    HireDate = "HireDate",
    ParticipantSigDate = "ParticipantSigDate",
    CaregiverSigDate = "CaregiverSigDate",
    ServiceData = "ServiceData",
    DuplicateShift = "DuplicateShift",
    NonHourlyUnits = "NonHourlyUnits",
    PersonId = "PersonId",
    DocumentBad = "DocumentBad",
    BudgetQuantity = "BudgetQuantity",
    DocTypeThresholdExceeded = "DocTypeThresholdExceeded",
    Task = "Task",
    RowInitials = "RowInitials",
    RangeOverBudgetUnits = "RangeOverBudgetUnits",
    Hospital = "Hospital",
    RequireAdjust = "RequireAdjust",
    HoursOverDailyLimit = "HoursOverDailyLimit",
    MonthlyUnitsAllocation = "MonthlyUnitsAllocation",
    Exceeded24Hours = "Exceeded24Hours",
    LiveIn = "LiveIn",
    CanPaperTimesheet = "CanPaperTimesheet",
    OverInternalAuth = "OverInternalAuth",
    MissingInternalAuth = "MissingInternalAuth",
    OkToWork = "OkToWork",
    OkToDrive = "OkToDrive",
    OkToAllocate = "OkToAllocate",
    ExemptionOverlap = "ExemptionOverlap",
    RoundShift = "RoundShift",
    ExternalId = "ExternalId",
    MonthlyServiceType = "MonthlyServiceType",
    ExceededServiceCodeUsageLimit = "ExceededServiceCodeUsageLimit",
    ParticipantStatus = "ParticipantStatus",
    CaregiverStatus = "CaregiverStatus",
    RangeOverBudgetDollars = "RangeOverBudgetDollars",
    PersonActionRule = "PersonActionRule",
    ServiceCutoff = "ServiceCutoff",
    PrerequisiteServiceValidation = "PrerequisiteServiceValidation",
    PayrollExternalKey = "PayrollExternalKey",
    ExceededDailyWorkLimit = "ExceededDailyWorkLimit",
    ExclusionaryService = "ExclusionaryService",
    ExceededRelationshipWWL = "ExceededRelationshipWWL",
    NoComments = "NoComments",
    Vendor = "Vendor",
    ParticipantVendor = "ParticipantVendor",
    VendorDocumentValidation = "VendorDocumentValidation",
    UnitsOverDailyLimit = "UnitsOverDailyLimit",
}

export class RuleOverrideDTO implements IRuleOverrideDTO {
    apiRuleID?: string | undefined;

    constructor(data?: IRuleOverrideDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiRuleID = _data["apiRuleID"];
        }
    }

    static fromJS(data: any): RuleOverrideDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RuleOverrideDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiRuleID"] = this.apiRuleID;
        return data;
    }
}

export interface IRuleOverrideDTO {
    apiRuleID?: string | undefined;
}

export class SetUtexStatusRequest implements ISetUtexStatusRequest {
    utexId!: number;
    utexStatus!: string;
    tcn!: string;

    constructor(data?: ISetUtexStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utexId = _data["utexId"];
            this.utexStatus = _data["utexStatus"];
            this.tcn = _data["tcn"];
        }
    }

    static fromJS(data: any): SetUtexStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetUtexStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utexId"] = this.utexId;
        data["utexStatus"] = this.utexStatus;
        data["tcn"] = this.tcn;
        return data;
    }
}

export interface ISetUtexStatusRequest {
    utexId: number;
    utexStatus: string;
    tcn: string;
}

export class SplitDTO implements ISplitDTO {
    originalUtexRecordId?: number;
    ruleId?: string | undefined;
    selectedErrorCodeId?: number;
    documentGroupId?: number;
    serviceCodeOne?: string | undefined;
    serviceCodeTwo?: string | undefined;
    serviceTimeInOne?: string | undefined;
    serviceTimeOutOne?: string | undefined;
    serviceTimeInTwo?: string | undefined;
    serviceTimeOutTwo?: string | undefined;
    payUnitsOne?: number;
    payUnitsTwo?: number;
    denyOne?: boolean;
    denyTwo?: boolean;
    companyId?: number;
    userId?: string | undefined;

    constructor(data?: ISplitDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalUtexRecordId = _data["originalUtexRecordId"];
            this.ruleId = _data["ruleId"];
            this.selectedErrorCodeId = _data["selectedErrorCodeId"];
            this.documentGroupId = _data["documentGroupId"];
            this.serviceCodeOne = _data["serviceCodeOne"];
            this.serviceCodeTwo = _data["serviceCodeTwo"];
            this.serviceTimeInOne = _data["serviceTimeInOne"];
            this.serviceTimeOutOne = _data["serviceTimeOutOne"];
            this.serviceTimeInTwo = _data["serviceTimeInTwo"];
            this.serviceTimeOutTwo = _data["serviceTimeOutTwo"];
            this.payUnitsOne = _data["payUnitsOne"];
            this.payUnitsTwo = _data["payUnitsTwo"];
            this.denyOne = _data["denyOne"];
            this.denyTwo = _data["denyTwo"];
            this.companyId = _data["companyId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): SplitDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SplitDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalUtexRecordId"] = this.originalUtexRecordId;
        data["ruleId"] = this.ruleId;
        data["selectedErrorCodeId"] = this.selectedErrorCodeId;
        data["documentGroupId"] = this.documentGroupId;
        data["serviceCodeOne"] = this.serviceCodeOne;
        data["serviceCodeTwo"] = this.serviceCodeTwo;
        data["serviceTimeInOne"] = this.serviceTimeInOne;
        data["serviceTimeOutOne"] = this.serviceTimeOutOne;
        data["serviceTimeInTwo"] = this.serviceTimeInTwo;
        data["serviceTimeOutTwo"] = this.serviceTimeOutTwo;
        data["payUnitsOne"] = this.payUnitsOne;
        data["payUnitsTwo"] = this.payUnitsTwo;
        data["denyOne"] = this.denyOne;
        data["denyTwo"] = this.denyTwo;
        data["companyId"] = this.companyId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ISplitDTO {
    originalUtexRecordId?: number;
    ruleId?: string | undefined;
    selectedErrorCodeId?: number;
    documentGroupId?: number;
    serviceCodeOne?: string | undefined;
    serviceCodeTwo?: string | undefined;
    serviceTimeInOne?: string | undefined;
    serviceTimeOutOne?: string | undefined;
    serviceTimeInTwo?: string | undefined;
    serviceTimeOutTwo?: string | undefined;
    payUnitsOne?: number;
    payUnitsTwo?: number;
    denyOne?: boolean;
    denyTwo?: boolean;
    companyId?: number;
    userId?: string | undefined;
}

export class SuspendedShiftRequest implements ISuspendedShiftRequest {
    companyCode!: string;
    ruleIDs?: RuleId[] | undefined;
    agedHours?: number;
    docType?: DocType;

    constructor(data?: ISuspendedShiftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyCode = _data["companyCode"];
            if (Array.isArray(_data["ruleIDs"])) {
                this.ruleIDs = [] as any;
                for (let item of _data["ruleIDs"])
                    this.ruleIDs!.push(item);
            }
            this.agedHours = _data["agedHours"];
            this.docType = _data["docType"];
        }
    }

    static fromJS(data: any): SuspendedShiftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SuspendedShiftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyCode"] = this.companyCode;
        if (Array.isArray(this.ruleIDs)) {
            data["ruleIDs"] = [];
            for (let item of this.ruleIDs)
                data["ruleIDs"].push(item);
        }
        data["agedHours"] = this.agedHours;
        data["docType"] = this.docType;
        return data;
    }
}

export interface ISuspendedShiftRequest {
    companyCode: string;
    ruleIDs?: RuleId[] | undefined;
    agedHours?: number;
    docType?: DocType;
}

export class TemporaryGracePeriodReasonsDto implements ITemporaryGracePeriodReasonsDto {
    errorCodeId?: number;
    mappingId?: number;
    reasonId?: number;
    reasonDescription?: string | undefined;
    resolutionId?: number;

    constructor(data?: ITemporaryGracePeriodReasonsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorCodeId = _data["errorCodeId"];
            this.mappingId = _data["mappingId"];
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.resolutionId = _data["resolutionId"];
        }
    }

    static fromJS(data: any): TemporaryGracePeriodReasonsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemporaryGracePeriodReasonsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorCodeId"] = this.errorCodeId;
        data["mappingId"] = this.mappingId;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["resolutionId"] = this.resolutionId;
        return data;
    }
}

export interface ITemporaryGracePeriodReasonsDto {
    errorCodeId?: number;
    mappingId?: number;
    reasonId?: number;
    reasonDescription?: string | undefined;
    resolutionId?: number;
}

export class UtexDTO implements IUtexDTO {
    acct?: string | undefined;
    acctExp?: string | undefined;
    acctSub?: string | undefined;
    agreeNbr?: string | undefined;
    agreeNbrMan?: string | undefined;
    apMail?: string | undefined;
    bD_RecordID?: number;
    bD_Status?: string | undefined;
    bH_Status?: string | undefined;
    billRate?: number;
    billRateMan?: number;
    billStatus?: string | undefined;
    billTotal?: number;
    billUnits?: number;
    billUnitsMan?: number;
    budgetHoursTotal?: number;
    carrierID?: string | undefined;
    cpnyCode!: string;
    crtd_DateTime?: Date;
    custId?: string | undefined;
    custNameFirst?: string | undefined;
    custNameLast?: string | undefined;
    documentBad?: number;
    documentId?: number;
    docRow?: number;
    earnType?: string | undefined;
    einId?: string | undefined;
    empId?: string | undefined;
    empNameFirst?: string | undefined;
    empNameLast?: string | undefined;
    exTranId?: string | undefined;
    hcpcs?: string | undefined;
    hcpcsMan?: string | undefined;
    holiFlag?: string | undefined;
    hospital?: boolean;
    hoursTotal?: number;
    invcNbr?: string | undefined;
    lUpd_DateTime?: Date;
    notes?: string | undefined;
    parentId?: number;
    payDate?: Date;
    payRate?: number;
    payRateMan?: number;
    payStatus?: string | undefined;
    payTotal?: number;
    payUnits?: number;
    payUnitsMan?: number;
    plcOfServ?: string | undefined;
    program?: string | undefined;
    provNbr?: string | undefined;
    recordTypeCode!: string;
    rowInitials?: boolean;
    servCode?: string | undefined;
    servDate?: Date;
    servMMDD?: string | undefined;
    servStatus?: string | undefined;
    servTimeInCalc?: string | undefined;
    servTimeInMan?: string | undefined;
    servTimeOutCalc?: string | undefined;
    servTimeOutMan?: string | undefined;
    servTimeInActual?: Date | undefined;
    servTimeOutActual?: Date | undefined;
    servWeek?: number;
    sigCust?: number;
    sigCustDate?: Date | undefined;
    sigEmp?: number;
    sigEmpDate?: Date | undefined;
    sourceCode!: string;
    status?: number;
    task?: boolean;
    sysUpdateTime?: Date | undefined;
    unitType?: string | undefined;
    utexid?: number | undefined;
    vendId?: string | undefined;
    vendName?: string | undefined;
    clientChosenVendorId?: string | undefined;
    weekStart?: Date | undefined;
    requiresAdjustment?: number | undefined;
    servTimeInMan_Orig?: string | undefined;
    servTimeOutMan_Orig?: string | undefined;
    tcn?: string | undefined;
    refTCN?: string | undefined;
    origTCN?: string | undefined;
    docType!: string;

    constructor(data?: IUtexDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acct = _data["acct"];
            this.acctExp = _data["acctExp"];
            this.acctSub = _data["acctSub"];
            this.agreeNbr = _data["agreeNbr"];
            this.agreeNbrMan = _data["agreeNbrMan"];
            this.apMail = _data["apMail"];
            this.bD_RecordID = _data["bD_RecordID"];
            this.bD_Status = _data["bD_Status"];
            this.bH_Status = _data["bH_Status"];
            this.billRate = _data["billRate"];
            this.billRateMan = _data["billRateMan"];
            this.billStatus = _data["billStatus"];
            this.billTotal = _data["billTotal"];
            this.billUnits = _data["billUnits"];
            this.billUnitsMan = _data["billUnitsMan"];
            this.budgetHoursTotal = _data["budgetHoursTotal"];
            this.carrierID = _data["carrierID"];
            this.cpnyCode = _data["cpnyCode"];
            this.crtd_DateTime = _data["crtd_DateTime"] ? new Date(_data["crtd_DateTime"].toString()) : undefined as any;
            this.custId = _data["custId"];
            this.custNameFirst = _data["custNameFirst"];
            this.custNameLast = _data["custNameLast"];
            this.documentBad = _data["documentBad"];
            this.documentId = _data["documentId"];
            this.docRow = _data["docRow"];
            this.earnType = _data["earnType"];
            this.einId = _data["einId"];
            this.empId = _data["empId"];
            this.empNameFirst = _data["empNameFirst"];
            this.empNameLast = _data["empNameLast"];
            this.exTranId = _data["exTranId"];
            this.hcpcs = _data["hcpcs"];
            this.hcpcsMan = _data["hcpcsMan"];
            this.holiFlag = _data["holiFlag"];
            this.hospital = _data["hospital"];
            this.hoursTotal = _data["hoursTotal"];
            this.invcNbr = _data["invcNbr"];
            this.lUpd_DateTime = _data["lUpd_DateTime"] ? new Date(_data["lUpd_DateTime"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.parentId = _data["parentId"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : undefined as any;
            this.payRate = _data["payRate"];
            this.payRateMan = _data["payRateMan"];
            this.payStatus = _data["payStatus"];
            this.payTotal = _data["payTotal"];
            this.payUnits = _data["payUnits"];
            this.payUnitsMan = _data["payUnitsMan"];
            this.plcOfServ = _data["plcOfServ"];
            this.program = _data["program"];
            this.provNbr = _data["provNbr"];
            this.recordTypeCode = _data["recordTypeCode"];
            this.rowInitials = _data["rowInitials"];
            this.servCode = _data["servCode"];
            this.servDate = _data["servDate"] ? new Date(_data["servDate"].toString()) : undefined as any;
            this.servMMDD = _data["servMMDD"];
            this.servStatus = _data["servStatus"];
            this.servTimeInCalc = _data["servTimeInCalc"];
            this.servTimeInMan = _data["servTimeInMan"];
            this.servTimeOutCalc = _data["servTimeOutCalc"];
            this.servTimeOutMan = _data["servTimeOutMan"];
            this.servTimeInActual = _data["servTimeInActual"] ? new Date(_data["servTimeInActual"].toString()) : undefined as any;
            this.servTimeOutActual = _data["servTimeOutActual"] ? new Date(_data["servTimeOutActual"].toString()) : undefined as any;
            this.servWeek = _data["servWeek"];
            this.sigCust = _data["sigCust"];
            this.sigCustDate = _data["sigCustDate"] ? new Date(_data["sigCustDate"].toString()) : undefined as any;
            this.sigEmp = _data["sigEmp"];
            this.sigEmpDate = _data["sigEmpDate"] ? new Date(_data["sigEmpDate"].toString()) : undefined as any;
            this.sourceCode = _data["sourceCode"];
            this.status = _data["status"];
            this.task = _data["task"];
            this.sysUpdateTime = _data["sysUpdateTime"] ? new Date(_data["sysUpdateTime"].toString()) : undefined as any;
            this.unitType = _data["unitType"];
            this.utexid = _data["utexid"];
            this.vendId = _data["vendId"];
            this.vendName = _data["vendName"];
            this.clientChosenVendorId = _data["clientChosenVendorId"];
            this.weekStart = _data["weekStart"] ? new Date(_data["weekStart"].toString()) : undefined as any;
            this.requiresAdjustment = _data["requiresAdjustment"];
            this.servTimeInMan_Orig = _data["servTimeInMan_Orig"];
            this.servTimeOutMan_Orig = _data["servTimeOutMan_Orig"];
            this.tcn = _data["tcn"];
            this.refTCN = _data["refTCN"];
            this.origTCN = _data["origTCN"];
            this.docType = _data["docType"];
        }
    }

    static fromJS(data: any): UtexDTO {
        data = typeof data === 'object' ? data : {};
        let result = new UtexDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acct"] = this.acct;
        data["acctExp"] = this.acctExp;
        data["acctSub"] = this.acctSub;
        data["agreeNbr"] = this.agreeNbr;
        data["agreeNbrMan"] = this.agreeNbrMan;
        data["apMail"] = this.apMail;
        data["bD_RecordID"] = this.bD_RecordID;
        data["bD_Status"] = this.bD_Status;
        data["bH_Status"] = this.bH_Status;
        data["billRate"] = this.billRate;
        data["billRateMan"] = this.billRateMan;
        data["billStatus"] = this.billStatus;
        data["billTotal"] = this.billTotal;
        data["billUnits"] = this.billUnits;
        data["billUnitsMan"] = this.billUnitsMan;
        data["budgetHoursTotal"] = this.budgetHoursTotal;
        data["carrierID"] = this.carrierID;
        data["cpnyCode"] = this.cpnyCode;
        data["crtd_DateTime"] = this.crtd_DateTime ? this.crtd_DateTime.toISOString() : undefined as any;
        data["custId"] = this.custId;
        data["custNameFirst"] = this.custNameFirst;
        data["custNameLast"] = this.custNameLast;
        data["documentBad"] = this.documentBad;
        data["documentId"] = this.documentId;
        data["docRow"] = this.docRow;
        data["earnType"] = this.earnType;
        data["einId"] = this.einId;
        data["empId"] = this.empId;
        data["empNameFirst"] = this.empNameFirst;
        data["empNameLast"] = this.empNameLast;
        data["exTranId"] = this.exTranId;
        data["hcpcs"] = this.hcpcs;
        data["hcpcsMan"] = this.hcpcsMan;
        data["holiFlag"] = this.holiFlag;
        data["hospital"] = this.hospital;
        data["hoursTotal"] = this.hoursTotal;
        data["invcNbr"] = this.invcNbr;
        data["lUpd_DateTime"] = this.lUpd_DateTime ? this.lUpd_DateTime.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["parentId"] = this.parentId;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : undefined as any;
        data["payRate"] = this.payRate;
        data["payRateMan"] = this.payRateMan;
        data["payStatus"] = this.payStatus;
        data["payTotal"] = this.payTotal;
        data["payUnits"] = this.payUnits;
        data["payUnitsMan"] = this.payUnitsMan;
        data["plcOfServ"] = this.plcOfServ;
        data["program"] = this.program;
        data["provNbr"] = this.provNbr;
        data["recordTypeCode"] = this.recordTypeCode;
        data["rowInitials"] = this.rowInitials;
        data["servCode"] = this.servCode;
        data["servDate"] = this.servDate ? this.servDate.toISOString() : undefined as any;
        data["servMMDD"] = this.servMMDD;
        data["servStatus"] = this.servStatus;
        data["servTimeInCalc"] = this.servTimeInCalc;
        data["servTimeInMan"] = this.servTimeInMan;
        data["servTimeOutCalc"] = this.servTimeOutCalc;
        data["servTimeOutMan"] = this.servTimeOutMan;
        data["servTimeInActual"] = this.servTimeInActual ? this.servTimeInActual.toISOString() : undefined as any;
        data["servTimeOutActual"] = this.servTimeOutActual ? this.servTimeOutActual.toISOString() : undefined as any;
        data["servWeek"] = this.servWeek;
        data["sigCust"] = this.sigCust;
        data["sigCustDate"] = this.sigCustDate ? this.sigCustDate.toISOString() : undefined as any;
        data["sigEmp"] = this.sigEmp;
        data["sigEmpDate"] = this.sigEmpDate ? this.sigEmpDate.toISOString() : undefined as any;
        data["sourceCode"] = this.sourceCode;
        data["status"] = this.status;
        data["task"] = this.task;
        data["sysUpdateTime"] = this.sysUpdateTime ? this.sysUpdateTime.toISOString() : undefined as any;
        data["unitType"] = this.unitType;
        data["utexid"] = this.utexid;
        data["vendId"] = this.vendId;
        data["vendName"] = this.vendName;
        data["clientChosenVendorId"] = this.clientChosenVendorId;
        data["weekStart"] = this.weekStart ? this.weekStart.toISOString() : undefined as any;
        data["requiresAdjustment"] = this.requiresAdjustment;
        data["servTimeInMan_Orig"] = this.servTimeInMan_Orig;
        data["servTimeOutMan_Orig"] = this.servTimeOutMan_Orig;
        data["tcn"] = this.tcn;
        data["refTCN"] = this.refTCN;
        data["origTCN"] = this.origTCN;
        data["docType"] = this.docType;
        return data;
    }
}

export interface IUtexDTO {
    acct?: string | undefined;
    acctExp?: string | undefined;
    acctSub?: string | undefined;
    agreeNbr?: string | undefined;
    agreeNbrMan?: string | undefined;
    apMail?: string | undefined;
    bD_RecordID?: number;
    bD_Status?: string | undefined;
    bH_Status?: string | undefined;
    billRate?: number;
    billRateMan?: number;
    billStatus?: string | undefined;
    billTotal?: number;
    billUnits?: number;
    billUnitsMan?: number;
    budgetHoursTotal?: number;
    carrierID?: string | undefined;
    cpnyCode: string;
    crtd_DateTime?: Date;
    custId?: string | undefined;
    custNameFirst?: string | undefined;
    custNameLast?: string | undefined;
    documentBad?: number;
    documentId?: number;
    docRow?: number;
    earnType?: string | undefined;
    einId?: string | undefined;
    empId?: string | undefined;
    empNameFirst?: string | undefined;
    empNameLast?: string | undefined;
    exTranId?: string | undefined;
    hcpcs?: string | undefined;
    hcpcsMan?: string | undefined;
    holiFlag?: string | undefined;
    hospital?: boolean;
    hoursTotal?: number;
    invcNbr?: string | undefined;
    lUpd_DateTime?: Date;
    notes?: string | undefined;
    parentId?: number;
    payDate?: Date;
    payRate?: number;
    payRateMan?: number;
    payStatus?: string | undefined;
    payTotal?: number;
    payUnits?: number;
    payUnitsMan?: number;
    plcOfServ?: string | undefined;
    program?: string | undefined;
    provNbr?: string | undefined;
    recordTypeCode: string;
    rowInitials?: boolean;
    servCode?: string | undefined;
    servDate?: Date;
    servMMDD?: string | undefined;
    servStatus?: string | undefined;
    servTimeInCalc?: string | undefined;
    servTimeInMan?: string | undefined;
    servTimeOutCalc?: string | undefined;
    servTimeOutMan?: string | undefined;
    servTimeInActual?: Date | undefined;
    servTimeOutActual?: Date | undefined;
    servWeek?: number;
    sigCust?: number;
    sigCustDate?: Date | undefined;
    sigEmp?: number;
    sigEmpDate?: Date | undefined;
    sourceCode: string;
    status?: number;
    task?: boolean;
    sysUpdateTime?: Date | undefined;
    unitType?: string | undefined;
    utexid?: number | undefined;
    vendId?: string | undefined;
    vendName?: string | undefined;
    clientChosenVendorId?: string | undefined;
    weekStart?: Date | undefined;
    requiresAdjustment?: number | undefined;
    servTimeInMan_Orig?: string | undefined;
    servTimeOutMan_Orig?: string | undefined;
    tcn?: string | undefined;
    refTCN?: string | undefined;
    origTCN?: string | undefined;
    docType: string;
}

export class UtexRecordDto implements IUtexRecordDto {
    utexId?: number;
    payorId?: string | undefined;
    cloudSyncFileId?: string | undefined;
    companyCodeId?: number;
    companyCode?: string | undefined;
    oldParticipantId?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    documentId?: number;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    externalTransactionId?: string | undefined;
    originalTCN?: string | undefined;
    parentId?: number;
    payUnits?: number;
    recordTypeId?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceTimeInManualOriginal?: string | undefined;
    serviceTimeInCalculated?: string | undefined;
    serviceTimeOutManualOriginal?: string | undefined;
    serviceTimeOutCalculated?: string | undefined;
    serviceTimeInActual?: Date;
    serviceTimeOutActual?: Date;
    sourceId?: number | undefined;
    sourceValue?: string | undefined;
    statusId?: number | undefined;
    tcn?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    agreementNumber?: string | undefined;
    billUnits?: number;
    billRate?: number;
    billTotal?: number;
    account?: string | undefined;
    accountExp?: string | undefined;
    accountSub?: string | undefined;
    billStatus?: string | undefined;
    payStatus?: string | undefined;
    payDate?: Date;
    payRate?: number;
    payTotal?: number;
    unitType?: string | undefined;
    earnType?: string | undefined;
    ein?: string | undefined;
    holiday?: string | undefined;
    apMail?: string | undefined;
    providerNumber?: string | undefined;
    program?: string | undefined;
    documentRow?: number;
    budgetStatus?: string | undefined;
    bdStatus?: string | undefined;
    bdId?: number;
    notes?: string | undefined;
    billRateManual?: number;
    billUnitsManual?: number;
    payRateManual?: number;
    payUnitsManual?: number;
    caregiverSigDate?: Date;
    participantSigDate?: Date;
    reasonId?: number | undefined;
    reasonDescription?: string | undefined;

    constructor(data?: IUtexRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utexId = _data["utexId"];
            this.payorId = _data["payorId"];
            this.cloudSyncFileId = _data["cloudSyncFileId"];
            this.companyCodeId = _data["companyCodeId"];
            this.companyCode = _data["companyCode"];
            this.oldParticipantId = _data["oldParticipantId"];
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"];
            this.documentId = _data["documentId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.externalTransactionId = _data["externalTransactionId"];
            this.originalTCN = _data["originalTCN"];
            this.parentId = _data["parentId"];
            this.payUnits = _data["payUnits"];
            this.recordTypeId = _data["recordTypeId"];
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : undefined as any;
            this.serviceTimeInManual = _data["serviceTimeInManual"];
            this.serviceTimeOutManual = _data["serviceTimeOutManual"];
            this.serviceTimeInManualOriginal = _data["serviceTimeInManualOriginal"];
            this.serviceTimeInCalculated = _data["serviceTimeInCalculated"];
            this.serviceTimeOutManualOriginal = _data["serviceTimeOutManualOriginal"];
            this.serviceTimeOutCalculated = _data["serviceTimeOutCalculated"];
            this.serviceTimeInActual = _data["serviceTimeInActual"] ? new Date(_data["serviceTimeInActual"].toString()) : undefined as any;
            this.serviceTimeOutActual = _data["serviceTimeOutActual"] ? new Date(_data["serviceTimeOutActual"].toString()) : undefined as any;
            this.sourceId = _data["sourceId"];
            this.sourceValue = _data["sourceValue"];
            this.statusId = _data["statusId"];
            this.tcn = _data["tcn"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.agreementNumber = _data["agreementNumber"];
            this.billUnits = _data["billUnits"];
            this.billRate = _data["billRate"];
            this.billTotal = _data["billTotal"];
            this.account = _data["account"];
            this.accountExp = _data["accountExp"];
            this.accountSub = _data["accountSub"];
            this.billStatus = _data["billStatus"];
            this.payStatus = _data["payStatus"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : undefined as any;
            this.payRate = _data["payRate"];
            this.payTotal = _data["payTotal"];
            this.unitType = _data["unitType"];
            this.earnType = _data["earnType"];
            this.ein = _data["ein"];
            this.holiday = _data["holiday"];
            this.apMail = _data["apMail"];
            this.providerNumber = _data["providerNumber"];
            this.program = _data["program"];
            this.documentRow = _data["documentRow"];
            this.budgetStatus = _data["budgetStatus"];
            this.bdStatus = _data["bdStatus"];
            this.bdId = _data["bdId"];
            this.notes = _data["notes"];
            this.billRateManual = _data["billRateManual"];
            this.billUnitsManual = _data["billUnitsManual"];
            this.payRateManual = _data["payRateManual"];
            this.payUnitsManual = _data["payUnitsManual"];
            this.caregiverSigDate = _data["caregiverSigDate"] ? new Date(_data["caregiverSigDate"].toString()) : undefined as any;
            this.participantSigDate = _data["participantSigDate"] ? new Date(_data["participantSigDate"].toString()) : undefined as any;
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
        }
    }

    static fromJS(data: any): UtexRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UtexRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utexId"] = this.utexId;
        data["payorId"] = this.payorId;
        data["cloudSyncFileId"] = this.cloudSyncFileId;
        data["companyCodeId"] = this.companyCodeId;
        data["companyCode"] = this.companyCode;
        data["oldParticipantId"] = this.oldParticipantId;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType;
        data["documentId"] = this.documentId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["externalTransactionId"] = this.externalTransactionId;
        data["originalTCN"] = this.originalTCN;
        data["parentId"] = this.parentId;
        data["payUnits"] = this.payUnits;
        data["recordTypeId"] = this.recordTypeId;
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : undefined as any;
        data["serviceTimeInManual"] = this.serviceTimeInManual;
        data["serviceTimeOutManual"] = this.serviceTimeOutManual;
        data["serviceTimeInManualOriginal"] = this.serviceTimeInManualOriginal;
        data["serviceTimeInCalculated"] = this.serviceTimeInCalculated;
        data["serviceTimeOutManualOriginal"] = this.serviceTimeOutManualOriginal;
        data["serviceTimeOutCalculated"] = this.serviceTimeOutCalculated;
        data["serviceTimeInActual"] = this.serviceTimeInActual ? this.serviceTimeInActual.toISOString() : undefined as any;
        data["serviceTimeOutActual"] = this.serviceTimeOutActual ? this.serviceTimeOutActual.toISOString() : undefined as any;
        data["sourceId"] = this.sourceId;
        data["sourceValue"] = this.sourceValue;
        data["statusId"] = this.statusId;
        data["tcn"] = this.tcn;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["agreementNumber"] = this.agreementNumber;
        data["billUnits"] = this.billUnits;
        data["billRate"] = this.billRate;
        data["billTotal"] = this.billTotal;
        data["account"] = this.account;
        data["accountExp"] = this.accountExp;
        data["accountSub"] = this.accountSub;
        data["billStatus"] = this.billStatus;
        data["payStatus"] = this.payStatus;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : undefined as any;
        data["payRate"] = this.payRate;
        data["payTotal"] = this.payTotal;
        data["unitType"] = this.unitType;
        data["earnType"] = this.earnType;
        data["ein"] = this.ein;
        data["holiday"] = this.holiday;
        data["apMail"] = this.apMail;
        data["providerNumber"] = this.providerNumber;
        data["program"] = this.program;
        data["documentRow"] = this.documentRow;
        data["budgetStatus"] = this.budgetStatus;
        data["bdStatus"] = this.bdStatus;
        data["bdId"] = this.bdId;
        data["notes"] = this.notes;
        data["billRateManual"] = this.billRateManual;
        data["billUnitsManual"] = this.billUnitsManual;
        data["payRateManual"] = this.payRateManual;
        data["payUnitsManual"] = this.payUnitsManual;
        data["caregiverSigDate"] = this.caregiverSigDate ? this.caregiverSigDate.toISOString() : undefined as any;
        data["participantSigDate"] = this.participantSigDate ? this.participantSigDate.toISOString() : undefined as any;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        return data;
    }
}

export interface IUtexRecordDto {
    utexId?: number;
    payorId?: string | undefined;
    cloudSyncFileId?: string | undefined;
    companyCodeId?: number;
    companyCode?: string | undefined;
    oldParticipantId?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    documentId?: number;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    externalTransactionId?: string | undefined;
    originalTCN?: string | undefined;
    parentId?: number;
    payUnits?: number;
    recordTypeId?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceTimeInManualOriginal?: string | undefined;
    serviceTimeInCalculated?: string | undefined;
    serviceTimeOutManualOriginal?: string | undefined;
    serviceTimeOutCalculated?: string | undefined;
    serviceTimeInActual?: Date;
    serviceTimeOutActual?: Date;
    sourceId?: number | undefined;
    sourceValue?: string | undefined;
    statusId?: number | undefined;
    tcn?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    agreementNumber?: string | undefined;
    billUnits?: number;
    billRate?: number;
    billTotal?: number;
    account?: string | undefined;
    accountExp?: string | undefined;
    accountSub?: string | undefined;
    billStatus?: string | undefined;
    payStatus?: string | undefined;
    payDate?: Date;
    payRate?: number;
    payTotal?: number;
    unitType?: string | undefined;
    earnType?: string | undefined;
    ein?: string | undefined;
    holiday?: string | undefined;
    apMail?: string | undefined;
    providerNumber?: string | undefined;
    program?: string | undefined;
    documentRow?: number;
    budgetStatus?: string | undefined;
    bdStatus?: string | undefined;
    bdId?: number;
    notes?: string | undefined;
    billRateManual?: number;
    billUnitsManual?: number;
    payRateManual?: number;
    payUnitsManual?: number;
    caregiverSigDate?: Date;
    participantSigDate?: Date;
    reasonId?: number | undefined;
    reasonDescription?: string | undefined;
}

export class UtexRecordsRequest implements IUtexRecordsRequest {
    careFirst?: string | undefined;
    careIds?: string[] | undefined;
    careLast?: string | undefined;
    ccIds?: number[] | undefined;
    dtIds?: number[] | undefined;
    docIds?: number[] | undefined;
    filter?: HttpFilterRequest;
    partFirst?: string | undefined;
    partIds?: string[] | undefined;
    partLast?: string | undefined;
    staIds?: number[] | undefined;
    errorCodes?: number[] | undefined;
    utexId?: number;
    exTransId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IUtexRecordsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.careFirst = _data["careFirst"];
            if (Array.isArray(_data["careIds"])) {
                this.careIds = [] as any;
                for (let item of _data["careIds"])
                    this.careIds!.push(item);
            }
            this.careLast = _data["careLast"];
            if (Array.isArray(_data["ccIds"])) {
                this.ccIds = [] as any;
                for (let item of _data["ccIds"])
                    this.ccIds!.push(item);
            }
            if (Array.isArray(_data["dtIds"])) {
                this.dtIds = [] as any;
                for (let item of _data["dtIds"])
                    this.dtIds!.push(item);
            }
            if (Array.isArray(_data["docIds"])) {
                this.docIds = [] as any;
                for (let item of _data["docIds"])
                    this.docIds!.push(item);
            }
            this.filter = _data["filter"] ? HttpFilterRequest.fromJS(_data["filter"]) : undefined as any;
            this.partFirst = _data["partFirst"];
            if (Array.isArray(_data["partIds"])) {
                this.partIds = [] as any;
                for (let item of _data["partIds"])
                    this.partIds!.push(item);
            }
            this.partLast = _data["partLast"];
            if (Array.isArray(_data["staIds"])) {
                this.staIds = [] as any;
                for (let item of _data["staIds"])
                    this.staIds!.push(item);
            }
            if (Array.isArray(_data["errorCodes"])) {
                this.errorCodes = [] as any;
                for (let item of _data["errorCodes"])
                    this.errorCodes!.push(item);
            }
            this.utexId = _data["utexId"];
            this.exTransId = _data["exTransId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UtexRecordsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UtexRecordsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["careFirst"] = this.careFirst;
        if (Array.isArray(this.careIds)) {
            data["careIds"] = [];
            for (let item of this.careIds)
                data["careIds"].push(item);
        }
        data["careLast"] = this.careLast;
        if (Array.isArray(this.ccIds)) {
            data["ccIds"] = [];
            for (let item of this.ccIds)
                data["ccIds"].push(item);
        }
        if (Array.isArray(this.dtIds)) {
            data["dtIds"] = [];
            for (let item of this.dtIds)
                data["dtIds"].push(item);
        }
        if (Array.isArray(this.docIds)) {
            data["docIds"] = [];
            for (let item of this.docIds)
                data["docIds"].push(item);
        }
        data["filter"] = this.filter ? this.filter.toJSON() : undefined as any;
        data["partFirst"] = this.partFirst;
        if (Array.isArray(this.partIds)) {
            data["partIds"] = [];
            for (let item of this.partIds)
                data["partIds"].push(item);
        }
        data["partLast"] = this.partLast;
        if (Array.isArray(this.staIds)) {
            data["staIds"] = [];
            for (let item of this.staIds)
                data["staIds"].push(item);
        }
        if (Array.isArray(this.errorCodes)) {
            data["errorCodes"] = [];
            for (let item of this.errorCodes)
                data["errorCodes"].push(item);
        }
        data["utexId"] = this.utexId;
        data["exTransId"] = this.exTransId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUtexRecordsRequest {
    careFirst?: string | undefined;
    careIds?: string[] | undefined;
    careLast?: string | undefined;
    ccIds?: number[] | undefined;
    dtIds?: number[] | undefined;
    docIds?: number[] | undefined;
    filter?: HttpFilterRequest;
    partFirst?: string | undefined;
    partIds?: string[] | undefined;
    partLast?: string | undefined;
    staIds?: number[] | undefined;
    errorCodes?: number[] | undefined;
    utexId?: number;
    exTransId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class ViewUtexRecordDTO implements IViewUtexRecordDTO {
    utexId?: number;
    payorId?: string | undefined;
    cloudSyncFileId?: string | undefined;
    companyCodeId?: number;
    companyCode?: string | undefined;
    oldParticipantId?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    documentId?: number;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    externalTransactionId?: string | undefined;
    originalTCN?: string | undefined;
    parentId?: number;
    payUnits?: number;
    recordTypeId?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceTimeInManualOriginal?: string | undefined;
    serviceTimeInCalculated?: string | undefined;
    serviceTimeOutManualOriginal?: string | undefined;
    serviceTimeOutCalculated?: string | undefined;
    serviceTimeInActual?: Date;
    serviceTimeOutActual?: Date;
    sourceId?: number | undefined;
    sourceValue?: string | undefined;
    statusId?: number | undefined;
    tcn?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    agreementNumber?: string | undefined;
    billUnits?: number;
    billRate?: number;
    billTotal?: number;
    account?: string | undefined;
    accountExp?: string | undefined;
    accountSub?: string | undefined;
    billStatus?: string | undefined;
    payStatus?: string | undefined;
    payDate?: Date;
    payRate?: number;
    payTotal?: number;
    unitType?: string | undefined;
    earnType?: string | undefined;
    ein?: string | undefined;
    holiday?: string | undefined;
    apMail?: string | undefined;
    providerNumber?: string | undefined;
    program?: string | undefined;
    documentRow?: number;
    budgetStatus?: string | undefined;
    bdStatus?: string | undefined;
    bdId?: number;
    notes?: string | undefined;
    billRateManual?: number;
    billUnitsManual?: number;
    payRateManual?: number;
    payUnitsManual?: number;
    caregiverSigDate?: Date;
    participantSigDate?: Date;
    reasonId?: number | undefined;
    reasonDescription?: string | undefined;
    exceptionId?: number;
    errorCodeId?: number;
    errorCodeValue?: string | undefined;
    exceptionAge?: number;
    utexAge?: number;
    sigCust?: number;
    sigCustDate?: Date | undefined;
    sigEmp?: number;
    sigEmpDate?: Date | undefined;
    rowInitials?: boolean;
    task?: boolean;
    allowShiftSplit?: boolean;
    historyExist?: boolean;
    notesExist?: boolean;
    isOverride?: boolean;
    ruleId?: string | undefined;
    vendorId?: string | undefined;
    vendorName?: string | undefined;
    clientChosenVendorId?: string | undefined;
    invoiceNumber?: string | undefined;
    resolution?: string | undefined;
    exception?: string | undefined;
    errorDesc?: string | undefined;
    statusString?: string | undefined;
    lastUpdatedTime?: Date;
    lastUpdatedBy?: string | undefined;
    systemUpdateTime?: Date;

    constructor(data?: IViewUtexRecordDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utexId = _data["utexId"];
            this.payorId = _data["payorId"];
            this.cloudSyncFileId = _data["cloudSyncFileId"];
            this.companyCodeId = _data["companyCodeId"];
            this.companyCode = _data["companyCode"];
            this.oldParticipantId = _data["oldParticipantId"];
            this.participantId = _data["participantId"];
            this.participantFirstName = _data["participantFirstName"];
            this.participantLastName = _data["participantLastName"];
            this.docTypeId = _data["docTypeId"];
            this.docType = _data["docType"];
            this.documentId = _data["documentId"];
            this.caregiverId = _data["caregiverId"];
            this.caregiverFirstName = _data["caregiverFirstName"];
            this.caregiverLastName = _data["caregiverLastName"];
            this.externalTransactionId = _data["externalTransactionId"];
            this.originalTCN = _data["originalTCN"];
            this.parentId = _data["parentId"];
            this.payUnits = _data["payUnits"];
            this.recordTypeId = _data["recordTypeId"];
            this.serviceCode = _data["serviceCode"];
            this.serviceDate = _data["serviceDate"] ? new Date(_data["serviceDate"].toString()) : undefined as any;
            this.serviceTimeInManual = _data["serviceTimeInManual"];
            this.serviceTimeOutManual = _data["serviceTimeOutManual"];
            this.serviceTimeInManualOriginal = _data["serviceTimeInManualOriginal"];
            this.serviceTimeInCalculated = _data["serviceTimeInCalculated"];
            this.serviceTimeOutManualOriginal = _data["serviceTimeOutManualOriginal"];
            this.serviceTimeOutCalculated = _data["serviceTimeOutCalculated"];
            this.serviceTimeInActual = _data["serviceTimeInActual"] ? new Date(_data["serviceTimeInActual"].toString()) : undefined as any;
            this.serviceTimeOutActual = _data["serviceTimeOutActual"] ? new Date(_data["serviceTimeOutActual"].toString()) : undefined as any;
            this.sourceId = _data["sourceId"];
            this.sourceValue = _data["sourceValue"];
            this.statusId = _data["statusId"];
            this.tcn = _data["tcn"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.updatedBy = _data["updatedBy"];
            this.agreementNumber = _data["agreementNumber"];
            this.billUnits = _data["billUnits"];
            this.billRate = _data["billRate"];
            this.billTotal = _data["billTotal"];
            this.account = _data["account"];
            this.accountExp = _data["accountExp"];
            this.accountSub = _data["accountSub"];
            this.billStatus = _data["billStatus"];
            this.payStatus = _data["payStatus"];
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : undefined as any;
            this.payRate = _data["payRate"];
            this.payTotal = _data["payTotal"];
            this.unitType = _data["unitType"];
            this.earnType = _data["earnType"];
            this.ein = _data["ein"];
            this.holiday = _data["holiday"];
            this.apMail = _data["apMail"];
            this.providerNumber = _data["providerNumber"];
            this.program = _data["program"];
            this.documentRow = _data["documentRow"];
            this.budgetStatus = _data["budgetStatus"];
            this.bdStatus = _data["bdStatus"];
            this.bdId = _data["bdId"];
            this.notes = _data["notes"];
            this.billRateManual = _data["billRateManual"];
            this.billUnitsManual = _data["billUnitsManual"];
            this.payRateManual = _data["payRateManual"];
            this.payUnitsManual = _data["payUnitsManual"];
            this.caregiverSigDate = _data["caregiverSigDate"] ? new Date(_data["caregiverSigDate"].toString()) : undefined as any;
            this.participantSigDate = _data["participantSigDate"] ? new Date(_data["participantSigDate"].toString()) : undefined as any;
            this.reasonId = _data["reasonId"];
            this.reasonDescription = _data["reasonDescription"];
            this.exceptionId = _data["exceptionId"];
            this.errorCodeId = _data["errorCodeId"];
            this.errorCodeValue = _data["errorCodeValue"];
            this.exceptionAge = _data["exceptionAge"];
            this.utexAge = _data["utexAge"];
            this.sigCust = _data["sigCust"];
            this.sigCustDate = _data["sigCustDate"] ? new Date(_data["sigCustDate"].toString()) : undefined as any;
            this.sigEmp = _data["sigEmp"];
            this.sigEmpDate = _data["sigEmpDate"] ? new Date(_data["sigEmpDate"].toString()) : undefined as any;
            this.rowInitials = _data["rowInitials"];
            this.task = _data["task"];
            this.allowShiftSplit = _data["allowShiftSplit"];
            this.historyExist = _data["historyExist"];
            this.notesExist = _data["notesExist"];
            this.isOverride = _data["isOverride"];
            this.ruleId = _data["ruleId"];
            this.vendorId = _data["vendorId"];
            this.vendorName = _data["vendorName"];
            this.clientChosenVendorId = _data["clientChosenVendorId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.resolution = _data["resolution"];
            this.exception = _data["exception"];
            this.errorDesc = _data["errorDesc"];
            this.statusString = _data["statusString"];
            this.lastUpdatedTime = _data["lastUpdatedTime"] ? new Date(_data["lastUpdatedTime"].toString()) : undefined as any;
            this.lastUpdatedBy = _data["lastUpdatedBy"];
            this.systemUpdateTime = _data["systemUpdateTime"] ? new Date(_data["systemUpdateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ViewUtexRecordDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ViewUtexRecordDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utexId"] = this.utexId;
        data["payorId"] = this.payorId;
        data["cloudSyncFileId"] = this.cloudSyncFileId;
        data["companyCodeId"] = this.companyCodeId;
        data["companyCode"] = this.companyCode;
        data["oldParticipantId"] = this.oldParticipantId;
        data["participantId"] = this.participantId;
        data["participantFirstName"] = this.participantFirstName;
        data["participantLastName"] = this.participantLastName;
        data["docTypeId"] = this.docTypeId;
        data["docType"] = this.docType;
        data["documentId"] = this.documentId;
        data["caregiverId"] = this.caregiverId;
        data["caregiverFirstName"] = this.caregiverFirstName;
        data["caregiverLastName"] = this.caregiverLastName;
        data["externalTransactionId"] = this.externalTransactionId;
        data["originalTCN"] = this.originalTCN;
        data["parentId"] = this.parentId;
        data["payUnits"] = this.payUnits;
        data["recordTypeId"] = this.recordTypeId;
        data["serviceCode"] = this.serviceCode;
        data["serviceDate"] = this.serviceDate ? this.serviceDate.toISOString() : undefined as any;
        data["serviceTimeInManual"] = this.serviceTimeInManual;
        data["serviceTimeOutManual"] = this.serviceTimeOutManual;
        data["serviceTimeInManualOriginal"] = this.serviceTimeInManualOriginal;
        data["serviceTimeInCalculated"] = this.serviceTimeInCalculated;
        data["serviceTimeOutManualOriginal"] = this.serviceTimeOutManualOriginal;
        data["serviceTimeOutCalculated"] = this.serviceTimeOutCalculated;
        data["serviceTimeInActual"] = this.serviceTimeInActual ? this.serviceTimeInActual.toISOString() : undefined as any;
        data["serviceTimeOutActual"] = this.serviceTimeOutActual ? this.serviceTimeOutActual.toISOString() : undefined as any;
        data["sourceId"] = this.sourceId;
        data["sourceValue"] = this.sourceValue;
        data["statusId"] = this.statusId;
        data["tcn"] = this.tcn;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["updatedBy"] = this.updatedBy;
        data["agreementNumber"] = this.agreementNumber;
        data["billUnits"] = this.billUnits;
        data["billRate"] = this.billRate;
        data["billTotal"] = this.billTotal;
        data["account"] = this.account;
        data["accountExp"] = this.accountExp;
        data["accountSub"] = this.accountSub;
        data["billStatus"] = this.billStatus;
        data["payStatus"] = this.payStatus;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : undefined as any;
        data["payRate"] = this.payRate;
        data["payTotal"] = this.payTotal;
        data["unitType"] = this.unitType;
        data["earnType"] = this.earnType;
        data["ein"] = this.ein;
        data["holiday"] = this.holiday;
        data["apMail"] = this.apMail;
        data["providerNumber"] = this.providerNumber;
        data["program"] = this.program;
        data["documentRow"] = this.documentRow;
        data["budgetStatus"] = this.budgetStatus;
        data["bdStatus"] = this.bdStatus;
        data["bdId"] = this.bdId;
        data["notes"] = this.notes;
        data["billRateManual"] = this.billRateManual;
        data["billUnitsManual"] = this.billUnitsManual;
        data["payRateManual"] = this.payRateManual;
        data["payUnitsManual"] = this.payUnitsManual;
        data["caregiverSigDate"] = this.caregiverSigDate ? this.caregiverSigDate.toISOString() : undefined as any;
        data["participantSigDate"] = this.participantSigDate ? this.participantSigDate.toISOString() : undefined as any;
        data["reasonId"] = this.reasonId;
        data["reasonDescription"] = this.reasonDescription;
        data["exceptionId"] = this.exceptionId;
        data["errorCodeId"] = this.errorCodeId;
        data["errorCodeValue"] = this.errorCodeValue;
        data["exceptionAge"] = this.exceptionAge;
        data["utexAge"] = this.utexAge;
        data["sigCust"] = this.sigCust;
        data["sigCustDate"] = this.sigCustDate ? this.sigCustDate.toISOString() : undefined as any;
        data["sigEmp"] = this.sigEmp;
        data["sigEmpDate"] = this.sigEmpDate ? this.sigEmpDate.toISOString() : undefined as any;
        data["rowInitials"] = this.rowInitials;
        data["task"] = this.task;
        data["allowShiftSplit"] = this.allowShiftSplit;
        data["historyExist"] = this.historyExist;
        data["notesExist"] = this.notesExist;
        data["isOverride"] = this.isOverride;
        data["ruleId"] = this.ruleId;
        data["vendorId"] = this.vendorId;
        data["vendorName"] = this.vendorName;
        data["clientChosenVendorId"] = this.clientChosenVendorId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["resolution"] = this.resolution;
        data["exception"] = this.exception;
        data["errorDesc"] = this.errorDesc;
        data["statusString"] = this.statusString;
        data["lastUpdatedTime"] = this.lastUpdatedTime ? this.lastUpdatedTime.toISOString() : undefined as any;
        data["lastUpdatedBy"] = this.lastUpdatedBy;
        data["systemUpdateTime"] = this.systemUpdateTime ? this.systemUpdateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface IViewUtexRecordDTO {
    utexId?: number;
    payorId?: string | undefined;
    cloudSyncFileId?: string | undefined;
    companyCodeId?: number;
    companyCode?: string | undefined;
    oldParticipantId?: string | undefined;
    participantId?: string | undefined;
    participantFirstName?: string | undefined;
    participantLastName?: string | undefined;
    docTypeId?: number | undefined;
    docType?: string | undefined;
    documentId?: number;
    caregiverId?: string | undefined;
    caregiverFirstName?: string | undefined;
    caregiverLastName?: string | undefined;
    externalTransactionId?: string | undefined;
    originalTCN?: string | undefined;
    parentId?: number;
    payUnits?: number;
    recordTypeId?: number | undefined;
    serviceCode?: string | undefined;
    serviceDate?: Date;
    serviceTimeInManual?: string | undefined;
    serviceTimeOutManual?: string | undefined;
    serviceTimeInManualOriginal?: string | undefined;
    serviceTimeInCalculated?: string | undefined;
    serviceTimeOutManualOriginal?: string | undefined;
    serviceTimeOutCalculated?: string | undefined;
    serviceTimeInActual?: Date;
    serviceTimeOutActual?: Date;
    sourceId?: number | undefined;
    sourceValue?: string | undefined;
    statusId?: number | undefined;
    tcn?: string | undefined;
    createdOn?: Date;
    createdBy?: string | undefined;
    updatedOn?: Date;
    updatedBy?: string | undefined;
    agreementNumber?: string | undefined;
    billUnits?: number;
    billRate?: number;
    billTotal?: number;
    account?: string | undefined;
    accountExp?: string | undefined;
    accountSub?: string | undefined;
    billStatus?: string | undefined;
    payStatus?: string | undefined;
    payDate?: Date;
    payRate?: number;
    payTotal?: number;
    unitType?: string | undefined;
    earnType?: string | undefined;
    ein?: string | undefined;
    holiday?: string | undefined;
    apMail?: string | undefined;
    providerNumber?: string | undefined;
    program?: string | undefined;
    documentRow?: number;
    budgetStatus?: string | undefined;
    bdStatus?: string | undefined;
    bdId?: number;
    notes?: string | undefined;
    billRateManual?: number;
    billUnitsManual?: number;
    payRateManual?: number;
    payUnitsManual?: number;
    caregiverSigDate?: Date;
    participantSigDate?: Date;
    reasonId?: number | undefined;
    reasonDescription?: string | undefined;
    exceptionId?: number;
    errorCodeId?: number;
    errorCodeValue?: string | undefined;
    exceptionAge?: number;
    utexAge?: number;
    sigCust?: number;
    sigCustDate?: Date | undefined;
    sigEmp?: number;
    sigEmpDate?: Date | undefined;
    rowInitials?: boolean;
    task?: boolean;
    allowShiftSplit?: boolean;
    historyExist?: boolean;
    notesExist?: boolean;
    isOverride?: boolean;
    ruleId?: string | undefined;
    vendorId?: string | undefined;
    vendorName?: string | undefined;
    clientChosenVendorId?: string | undefined;
    invoiceNumber?: string | undefined;
    resolution?: string | undefined;
    exception?: string | undefined;
    errorDesc?: string | undefined;
    statusString?: string | undefined;
    lastUpdatedTime?: Date;
    lastUpdatedBy?: string | undefined;
    systemUpdateTime?: Date;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}